import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { useParams, useNavigate, useSearchParams} from 'react-router-dom';
import { io } from 'socket.io-client';
import logo from '../../assets/logo.png';
import drop from '../../assets/icons/dropdown.svg';
import AccountStatement from '../user/AccountStatement';
import cricketService from '../../services/cricketAPI';
import CurrentBets from '../user/CurrentBets';
import ChangePassword from '../user/ChangePassword';
import { useAuth } from '../context/AuthContext';
import bettingService from '../../services/bettingAPI';
import { userDashboardAPI } from '../../services/api';
import '../../styles/cricket/UnifiedMatchDetails.css';
import toast from 'react-hot-toast';
import MatchTVStream from './MatchTVStream';

import ReactDOM from 'react-dom';

import { createPortal } from 'react-dom';

// Debounce utility function
function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

    const showLocked = () => {
    toast.error("User is locked");
};

    const SCOREBOARD_ORIGIN = 'https://dzfytm4o128av.cloudfront.net';

    const UnifiedMatchDetails = () => {


    const [mobileTab, setMobileTab] = useState('odds');

    const [loading, setLoading] = useState(false);
    const [matches, setMatches] = useState([]);
    const [filteredMatches, setFilteredMatches] = useState([]);
    const [lastUpdated, setLastUpdated] = useState(null);
    const [error, setError] = useState(null); // <-- ADD THIS MISSING LINE

    // Add this with your other states
    const [userSessionBets, setUserSessionBets] = useState({});
    const [loadingSessionBets, setLoadingSessionBets] = useState(false);
  


    const { marketId } = useParams();
    const navigate = useNavigate();


    const [matchState, setMatchState] = useState({
        matchOdds: [],
        tiedMatchMarkets: [],
        bookmakerMarkets: [],
        bookmakerTiedMarkets: [],
        bm1Markets: [],
        sessionMarkets: [],
        liveScore: null,
        connectionStatus: 'connecting',
        lastUpdate: null,
        matchInfo: null,
        matches: []  
    });

    
  
   

    const fetchMatches = async () => {
        try {
            setLoading(true);
            // Use the new method
            const data = await cricketService.getAllMatches();
            setMatches(data.sport.body);
            setFilteredMatches(data.sport.body); // Set filtered matches to all matches
            setLastUpdated(new Date());
            setError(null);
            
            // --- JUST ADD THESE 2 LINES BELOW ---
            setMatchState(prev => ({ ...prev, matches: data.sport.body }));
            // ------------------------------------
            
        } catch (err) {
            console.error('Fetch error:', err);
            setError('Failed to fetch live cricket matches. Please try again later.');
        } finally {
            setLoading(false);
        }
    };

    const [activeDropdown, setActiveDropdown] = useState(false);
    const [statsLoading, setStatsLoading] = useState(false);
    const dropdownRef = useRef(null);
    const [scoreConnected, setScoreConnected] = useState(false);

    const [activeModal, setActiveModal] = useState(null);
    const [searchParams] = useSearchParams();
    const gmid = searchParams.get('gmid');
    const scoreboardFrameRef = useRef(null);
    const scoreboardHandshakeRef = useRef(null);
    const scoreboardHandshakeTimeoutRef = useRef(null);
    const [scoreboardHeight, setScoreboardHeight] = useState(null);

    useEffect(() => {
        const handleScoreboardResize = (event) => {
            if (
                event.origin !== SCOREBOARD_ORIGIN ||
                event.source !== scoreboardFrameRef.current?.contentWindow ||
                !event.data ||
                event.data.type !== 'scoreboard:resize' ||
                event.data.version !== 1 ||
                !Number.isFinite(event.data.height) ||
                event.data.height < 48
            ) {
                return;
            }

            setScoreboardHeight(Math.ceil(event.data.height));
            window.clearInterval(scoreboardHandshakeRef.current);
            window.clearTimeout(scoreboardHandshakeTimeoutRef.current);
            scoreboardHandshakeRef.current = null;
            scoreboardHandshakeTimeoutRef.current = null;
        };

        window.addEventListener('message', handleScoreboardResize);
        return () => {
            window.removeEventListener('message', handleScoreboardResize);
            window.clearInterval(scoreboardHandshakeRef.current);
            window.clearTimeout(scoreboardHandshakeTimeoutRef.current);
        };
    }, []);

    const connectScoreboardResize = () => {
        scoreboardFrameRef.current?.contentWindow?.postMessage(
            { type: 'scoreboard:resize:connect', version: 1 },
            SCOREBOARD_ORIGIN
        );
    };

    const handleScoreboardLoad = () => {
        window.clearInterval(scoreboardHandshakeRef.current);
        window.clearTimeout(scoreboardHandshakeTimeoutRef.current);
        connectScoreboardResize();
        scoreboardHandshakeRef.current = window.setInterval(connectScoreboardResize, 250);
        scoreboardHandshakeTimeoutRef.current = window.setTimeout(() => {
            window.clearInterval(scoreboardHandshakeRef.current);
            scoreboardHandshakeRef.current = null;
            scoreboardHandshakeTimeoutRef.current = null;
        }, 10000);
    };

    const isVirtualMatch = useMemo(() => {
        return (marketId?.toString().startsWith('v') || gmid?.toString().startsWith('v'));
    }, [marketId, gmid]);
    const oddsSocketRef = useRef(null);
    const scoreSocketRef = useRef(null);
    
    const [showTV, setShowTV] = useState(false);
    
  
    const { user, logout } = useAuth();

    // Add position state
const [bookmakerPosition, setBookmakerPosition] = useState(null);
const [bookmaker2Position, setBookmaker2Position] = useState(null);
const [loadingPosition, setLoadingPosition] = useState(false);

// Fetch market positions for bookmaker and bookmaker2
// Fetch market positions
const fetchMarketPositions = useCallback(async () => {
    if (!marketId) return;
    
    try {
        setLoadingPosition(true);
        const response = await bettingService.getMarketPosition(marketId);
        
        // Check the response structure
        if (response.success) {
            // The data is in response.data.data
            const positionData = response.data;
            
            // Extract bookmaker and bookmaker2 positions
            const bookmakerPos = positionData?.bookmaker || null;
            const bookmaker2Pos = positionData?.bookmaker2 || null;
            
            console.log('Bookmaker Position:', bookmakerPos);
            console.log('Bookmaker2 Position:', bookmaker2Pos);
            
            setBookmakerPosition(bookmakerPos);
            setBookmaker2Position(bookmaker2Pos);
        }
    } catch (error) {
        console.error('Error fetching positions:', error);
    } finally {
        setLoadingPosition(false);
    }
}, [marketId]);
    
    


    const handleLogout = async () => {
        try {
            await userDashboardAPI.logout();
            logout();
            navigate('/login');
        } catch (error) {
            console.error('Logout error:', error);
            logout();
            navigate('/login');
        }
    };

    const [showAllBets, setShowAllBets] = useState(true);
    const toggleAllBets = () => {
        setShowAllBets(!showAllBets);
    };

    const [userStats, setUserStats] = useState({
        balance: 0,
        exposure: 0,
        availableBalance: 0
    });

    const [currentMatchBets, setCurrentMatchBets] = useState({
        bookmaker: [],
        bookmaker2: [],
        bookmakerTied: [],
        session: []
    });

    const [selectedBet, setSelectedBet] = useState(null);
    const [betStake, setBetStake] = useState('');
    const [showBetSlip, setShowBetSlip] = useState(false);
    const [isPlacingBet, setIsPlacingBet] = useState(false);
    
    const matchDataRef = useRef({});
    const updateTimerRef = useRef(null);
    const socketRef = useRef(null);
    const statsIntervalRef = useRef(null);
    const positionIntervalRef = useRef(null);
    const betsIntervalRef = useRef(null);

    const refreshPositions = useCallback(async () => {
        await fetchMarketPositions();
    }, [fetchMarketPositions]);

    // ==========================================
    // ✅ CORRECT PLACEMENT FOR FETCH MATCHES
    // ==========================================
    useEffect(() => {
        fetchMatches();
    }, []);
    // ==========================================

    // Optimized user stats fetch - less frequent
    useEffect(() => {
        const fetchUserStats = async () => {
            try {
                setStatsLoading(true);
                
                const statsResponse = await userDashboardAPI.getDashboardStats();
                const exposureResponse = await bettingService.getUserExposure();
                
                let balance = 0;
                if (statsResponse?.data?.data?.balance !== undefined) {
                    balance = parseFloat(statsResponse.data.data.balance) || 0;
                } else if (statsResponse?.data?.balance !== undefined) {
                    balance = parseFloat(statsResponse.data.balance) || 0;
                }
                
                let exposure = 0;
                if (exposureResponse?.data) {
                    if (exposureResponse.data.totalExposure !== undefined) {
                        exposure = parseFloat(exposureResponse.data.totalExposure);
                    } else if (exposureResponse.data.exposure !== undefined) {
                        exposure = parseFloat(exposureResponse.data.exposure);
                    }
                }
                
                setUserStats({
                    balance,
                    exposure,
                    availableBalance: balance - exposure
                });
                
            } catch (error) {
                console.error('Error fetching user stats:', error);
                const balance = parseFloat(user?.balance) || 0;
                setUserStats({
                    balance,
                    exposure: 0,
                    availableBalance: balance
                });
            } finally {
                setStatsLoading(false);
            }
        };

        fetchUserStats();
        fetchMarketPositions();
        
        // Increased interval to 5 seconds instead of 2
        statsIntervalRef.current = setInterval(fetchUserStats, 5000);
        positionIntervalRef.current = setInterval(fetchMarketPositions, 5000);

        return () => {
            if (statsIntervalRef.current) {
                clearInterval(statsIntervalRef.current);
            }
            if (positionIntervalRef.current) {
                clearInterval(positionIntervalRef.current);
            }
        };
    }, [user, marketId]);

const isSessionMarketValid = (market) => {

    const name = market.RunnerName || '';

    const lower = name.toLowerCase().trim();

const startsWithDisabledCategory =

    /^(total|most|top|how\s+many)\b/i.test(lower) ||

    /^\d+(?:st|nd|rd|th)?\s*wkt\s*pship\b/i.test(lower);

if (startsWithDisabledCategory) {

    return false;

}

    // ============================================================

    // EXCLUDE: Markets that should NEVER appear

    // ============================================================

    const excludePatterns = [

        /highest scoring over/i,

        /total \d+(?:st|nd|rd|th)? over runs/i,

        /match \d+(?:st|nd|rd|th)? over run/i,

        /match \d+(?:st|nd|rd|th)? over runs/i,

        /total runs in over/i,

        /total over runs/i,

        /highest over/i,

        /lowest over/i,

        /bhav/i,

        /\d+\s*wkt\s*runs/i,

        /\d+\s*wkt\s*run\s*bhav/i

    ];

    // Check permanent exclusions first.

    for (const pattern of excludePatterns) {

        if (pattern.test(lower)) {

            return false;

        }

    }

    // ============================================================

    // ENABLE: X to Y BALLS RUNS

    //

    // Examples:

    // 1 to 25 Balls runs

    // 1 to 50 Balls runs

    // 1 to 75 Balls runs

    // 1 to 100 Balls runs

    // 10 to 20 Balls runs

    // etc.

    // ============================================================

    const isRangeBallsRuns =

        /\d+(?:\.\d+)?\s*to\s*\d+(?:\.\d+)?\s*balls?\s*runs?/i.test(lower);

    if (isRangeBallsRuns) {

        return true;

    }

    // ============================================================

    // ENABLE: MATCH 1st/2nd/etc BALLS RUNS

    //

    // Examples:

    // Match 1st 5 Balls runs

    // Match 2nd 10 Balls runs

    // Match 1st 20 Balls runs

    // ============================================================

    const isMatchBallsRuns =

        /\bmatch\b.*\b\d+(?:st|nd|rd|th)?\s*balls?\s*runs?\b/i.test(lower);

    if (isMatchBallsRuns) {

        return true;

    }

    // ============================================================

    // ENABLE: PLAYER-SPECIFIC MARKETS

    //

    // Runs

    // Boundaries

    // Sixes

    // Fours

    // Balls Faced

    //

    // Examples:

    // B Smith run

    // M Bouchier run

    // P Litchfield Boundaries

    // L Lee sixes

    // B Smith fours

    // How many Balls face by B Smith

    // ============================================================

    const isPlayerRun =

        /\bruns?\b/i.test(lower) &&

        !lower.includes('total match') &&

        !lower.includes('over');

    const isPlayerBoundaries =

        /\bboundar(?:y|ies)\b/i.test(lower);

    const isPlayerSixes =

        /\bsixes?\b/i.test(lower);

    const isPlayerFours =

        /\bfours?\b/i.test(lower);

    const isTossMarket = /\btoss\b/i.test(lower);

if (isTossMarket) {

    return true;

}

    const isBallsFaced =

        /balls?\s*face(?:d)?\s*(?:by)?/i.test(lower) ||

        /how\s+many\s+balls?\s+face/i.test(lower);

    if (

        isPlayerRun ||

        isPlayerBoundaries ||

        isPlayerSixes ||

        isPlayerFours ||

        isBallsFaced

    ) {

        return true;

    }

    // ============================================================

    // ENABLE: ALL TOTAL MATCH MARKETS

    //

    // Examples:

    // Total Match Fours

    // Total Match Sixes

    // Total Match Boundaries

    // Total Match Wides

    // Total Match Caught Outs

    // Total Match 30s

    // Total Match Runout

    // Total Match Fifties

    // Total Match Wickets

    // etc.

    //

    // NOTE:

    // The permanent exclusions above still take priority.

    // ============================================================

    const isTotalMatchMarket =

        /^total\s+match\b/i.test(lower);

    if (isTotalMatchMarket) {

        return true;

    }

    // ============================================================

    // ENABLE: MOST / PLAYER-SPECIFIC BOWLING & BATTING MARKETS

    //

    // Examples:

    // Most Dotballs By a Bowler

    // Most Runs Given by a Bowler

    // Most Wickets By a Bowler

    // Most Balls Faced By a Batsman

    // Most Runs By a Batsman

    // Most Fours By a Batsman

    // Most Sixes By a Batsman

    // etc.

    // ============================================================

    const isMostPlayerMarket =

        /\bmost\b.*\b(?:by|given\s+by)\b/i.test(lower);

    if (isMostPlayerMarket) {

        return true;

    }

    // ============================================================

    // ENABLE: FALL OF WICKET

    // ============================================================

    const isFallOfWicket =

        /fall\s+of\s+\d+(?:st|nd|rd|th)?\s*wkt/i.test(lower);

    if (isFallOfWicket) {

        return true;

    }

    // ============================================================

    // OVER-BASED MARKETS

    //

    // Only normal over-based markets that aren't caught by the

    // permanent exclusion list above.

    // ============================================================

    const overRunMatch =

        lower.match(/(\d+(?:\.\d+)?)\s*over\s*run/i);

    const overRunsMatch =

        lower.match(/(\d+(?:\.\d+)?)\s*over\s*runs/i);

    const isOverBased =

        overRunMatch || overRunsMatch;

    if (isOverBased) {

        return true;

    }



    return false;

};

    // Debounced version of fetchCurrentMatchBets
    const fetchCurrentMatchBets = useCallback(
        debounce(async () => {
            if (!marketId) return;
            
            try {
                const response = await bettingService.getCurrentBets({ limit: 100 });
                
                if (response?.data?.bets) {
                    const allBets = response.data.bets;
                    const filteredBets = allBets.filter(bet => bet.marketId === marketId);
                    
                    const bookmaker = filteredBets.filter(b => b.marketType === 'bookmaker');
                    const bookmaker2 = filteredBets.filter(b => b.marketType === 'bookmaker2');
                    const bookmakerTied = filteredBets.filter(b => b.marketType === 'bookmaker_tied');
                    const session = filteredBets.filter(b => b.marketType === 'session');
                    
                    setCurrentMatchBets({ bookmaker, bookmaker2, bookmakerTied, session });
                }
            } catch (error) {
                console.error('Error fetching current match bets:', error);
            }
        }, 3000), // 3 second debounce
        [marketId]
    );

    const fetchUserSessionBets = useCallback(async () => {
    if (!marketId) return;
    
    try {
        setLoadingSessionBets(true);
        const response = await bettingService.getUserSessionBets(marketId);
        
        if (response.success) {
            // Create a map for quick lookup by selection name
            const betsMap = {};
            response.data.bets.forEach(bet => {
                betsMap[bet.selectionName] = bet;
            });
            setUserSessionBets(betsMap);
        }
    } catch (error) {
        console.error('Error fetching session bets:', error);
    } finally {
        setLoadingSessionBets(false);
    }
}, [marketId]);

    // Fetch current bets with longer interval
useEffect(() => {
    if (!marketId) return;

    const fetchData = () => {
        fetchCurrentMatchBets();
        fetchUserSessionBets();
    };

    fetchData(); // initial call

    betsIntervalRef.current = setInterval(fetchData, 5000);

    return () => {
        if (betsIntervalRef.current) {
            clearInterval(betsIntervalRef.current);
        }
    };
}, [marketId]);

    const calculateBookmakerPnL = useCallback((bets) => {
        if (!bets || bets.length === 0) return null;
        
        const bySelection = {};
        bets.forEach(bet => {
            if (!bySelection[bet.selectionName]) {
                bySelection[bet.selectionName] = [];
            }
            bySelection[bet.selectionName].push(bet);
        });
        
        const results = [];
        
        for (const [selection, selectionBets] of Object.entries(bySelection)) {
            let totalBackPotential = 0;
            let totalLayLiability = 0;
            let totalBackStake = 0;
            let totalLayStake = 0;
            
            selectionBets.forEach(bet => {
                if (bet.betType === 'back') {
                    totalBackPotential += bet.potentialWin || 0;
                    totalBackStake += bet.stake || 0;
                } else {
                    totalLayLiability += bet.exposureAmount || 0;
                    totalLayStake += bet.stake || 0;
                }
            });
            
            const ifWins = totalBackPotential - totalLayLiability;
            const ifLoses = totalLayStake - totalBackStake;
            
            results.push({
                selection,
                ifWins: parseFloat(ifWins.toFixed(2)),
                ifLoses: parseFloat(ifLoses.toFixed(2)),
                betCount: selectionBets.length
            });
        }
        
        return results;
    }, []);

    const calculateSessionPnL = useCallback((bets) => {
        if (!bets || bets.length === 0) return [];
        
        return bets.map(bet => ({
            selection: bet.selectionName,
            target: `${bet.comparison || ''} ${bet.targetValue || ''}`,
            stake: bet.stake || 0,
            potentialWin: bet.potentialWin || 0,
            odds: bet.odds || 0
        }));
    }, []);

    const batchUpdate = useCallback((newData) => {
        if (updateTimerRef.current) {
            clearTimeout(updateTimerRef.current);
        }
        
        updateTimerRef.current = setTimeout(() => {
            setMatchState(prev => ({
                ...prev,
                ...newData,
                lastUpdate: new Date()
            }));
            updateTimerRef.current = null;
        }, 50); // Increased to 50ms for better batching
    }, []);

    useEffect(() => {
        const subscribeToMarket = async () => {
            try {
                await bettingService.subscribeToMarket(marketId,gmid);
                console.log(`✅ Subscribed to market ${marketId}`);
            } catch (error) {
                console.error('Error subscribing to market:', error);
            }
        };

        subscribeToMarket();

        return () => {
            const unsubscribe = async () => {
                try {
                    await bettingService.unsubscribeFromMarket(marketId,gmid);
                    console.log(`✅ Unsubscribed from market ${marketId}`);
                } catch (error) {
                    console.error('Error unsubscribing from market:', error);
                }
            };
            unsubscribe();
        };
    }, [marketId,gmid]);

    
useEffect(() => {
    // ========== 1. ODDS SOCKET ==========
    // Choose URL based on match type
    const oddsSocketUrl = isVirtualMatch 
        ? "https://bearcrypto.in"  // Virtual cricket odds
        : "https://allpenellexch.com:8443/";  // Live cricket odds
    
    console.log(`🔌 Connecting to odds server: ${oddsSocketUrl} (${isVirtualMatch ? 'VIRTUAL' : 'LIVE'})`);
    
    const oddsSocket = io(oddsSocketUrl, {
        transports: ["websocket"],
        rejectUnauthorized: false,
        reconnection: true,
        reconnectionAttempts: 10,
        reconnectionDelay: 2000,
        reconnectionDelayMax: 10000,
        timeout: 30000
    });

    oddsSocketRef.current = oddsSocket;

    oddsSocket.on("connect", () => {
        console.log(`🔌 Connected to ${isVirtualMatch ? 'VIRTUAL' : 'LIVE'} odds server`);
        setMatchState(prev => ({ ...prev, connectionStatus: 'connected' }));
        oddsSocket.emit("getOddData", { eventId: marketId });
    });

    oddsSocket.on("connect_error", (err) => {
        console.log(`❌ Odds Connection Error (${isVirtualMatch ? 'VIRTUAL' : 'LIVE'}):`, err.message);
        setMatchState(prev => ({ ...prev, connectionStatus: 'error' }));
    });

    oddsSocket.on("disconnect", () => {
        console.log(`🔌 Odds Disconnected (${isVirtualMatch ? 'VIRTUAL' : 'LIVE'})`);
        setMatchState(prev => ({ ...prev, connectionStatus: 'disconnected' }));
    });

    oddsSocket.on("eventGetLiveEventsFancyData", (data) => {
        if (data.body) {
            processIncomingData(data.body);
        }
    });

    // ========== 2. SCORE SOCKET ==========
    let scoreSocket = null;

    if (gmid) {
        const scoreSocketUrl = isVirtualMatch
            ? "https://bearcrypto.in"  // Virtual cricket score
            : "wss://dimclscore.external247services.com";  // Live cricket score
        
        console.log(`📡 Initializing score socket for ${isVirtualMatch ? 'VIRTUAL' : 'LIVE'} match ${gmid} - URL: ${scoreSocketUrl}`);
        
        scoreSocket = io(scoreSocketUrl, {
            transports: ["websocket"],
            rejectUnauthorized: false,
            reconnection: true,
            reconnectionAttempts: 10,
            reconnectionDelay: 2000,
            reconnectionDelayMax: 10000,
            timeout: 30000
        });

        scoreSocketRef.current = scoreSocket;
        setScoreConnected(false);

        // Helper function to process score data - FIXED
        const processScoreData = (data) => {
            if (!data) return;
            
            console.log(`📊 Processing score data for ${isVirtualMatch ? 'VIRTUAL' : 'LIVE'} match:`, data);
            
            let scoreData = data;
            
            if (isVirtualMatch) {
                if (data.data && data.data.data) {
                    scoreData = data.data.data;
                } else if (data.data) {
                    scoreData = data.data;
                } else if (data.type === 1 && data.data) {
                    scoreData = data.data;
                }
            } else {
                if (data.summary && data.summary.data) {
                    scoreData = data.summary.data;
                } else if (data.data && data.data.data) {
                    scoreData = data.data.data;
                }
            }
            
            // ✅ FIX: Even if team names are missing, we still want to update the board with blank data
            // This prevents "invalid packet" early returns from crashing the UI state
            const formattedScore = {
                data: {
                    spnnation1: scoreData.spnnation1 || 'TBC',
                    spnnation2: scoreData.spnnation2 || 'TBC',
                    score1: scoreData.score1 || '0-0 (0.0)',
                    score2: scoreData.score2 || '0-0 (0.0)',
                    spnrunrate1: scoreData.spnrunrate1 || '0.0',
                    spnrunrate2: scoreData.spnrunrate2 || '0.0',
                    spnmessage: scoreData.spnmessage || 'In Progress',
                    spnballrunningstatus: scoreData.spnballrunningstatus || '',
                    spnreqrate1: scoreData.spnreqrate1 || '',
                    spnreqrate2: scoreData.spnreqrate2 || '',
                    dayno: scoreData.dayno || '',
                    isfinished: scoreData.isfinished || '0',
                    activenation1: scoreData.activenation1 || '0',
                    activenation2: scoreData.activenation2 || '0',
                    balls: scoreData.balls || []
                }
            };
            
            console.log("📊 Updating score UI:", formattedScore.data.score1, formattedScore.data.score2);
            
            setMatchState(prev => ({
                ...prev,
                liveScore: formattedScore,
                lastUpdate: new Date()
            }));
        };

        scoreSocket.on("connect", () => {
            console.log(`📡 Connected to ${isVirtualMatch ? 'VIRTUAL' : 'LIVE'} score server for game ${gmid}`);
            setScoreConnected(true);
            
            if (isVirtualMatch) {
                // For virtual matches, join match room and request live score
                scoreSocket.emit("join_match", gmid);
                scoreSocket.emit("liveScore", { eventId: gmid });
                scoreSocket.emit("get_match_status", gmid);
            } else {
                // For live matches, subscribe to external service
                scoreSocket.emit("subscribe_event", {
                    eventId: gmid.toString(),
                    providerId: "1"
                });
            }
        });

        scoreSocket.on("connect_error", (err) => {
            console.log(`❌ Score Connection Error (${isVirtualMatch ? 'VIRTUAL' : 'LIVE'}):`, err.message);
            setScoreConnected(false);
        });

        scoreSocket.on("disconnect", (reason) => {
            console.log(`📡 Score Disconnected (${isVirtualMatch ? 'VIRTUAL' : 'LIVE'}):`, reason);
            setScoreConnected(false);
        });

        // Handle score updates based on match type
        if (isVirtualMatch) {
            // Virtual match score events
            scoreSocket.on("liveScore", (data) => {
                console.log("📊 Virtual match liveScore received:", data);
                processScoreData(data);
            });
            
            scoreSocket.on("liveScore2", (data) => {
                console.log("📊 Virtual match liveScore2 received:", data);
                processScoreData(data);
            });
            
            scoreSocket.on("match_data", (data) => {
                console.log("📊 Virtual match data received:", data);
                // You can update match info here if needed
            });
            
            // Also listen for odds updates through score socket if needed
            scoreSocket.on("eventGetLiveEventsFancyData", (data) => {
                console.log("📊 Virtual match odds update:", data);
                if (data.body) {
                    processIncomingData(data.body);
                }
            });
            
            // Listen for ball updates
            scoreSocket.on("ball_update", (data) => {
                console.log("🏏 Ball update:", data);
                // Refresh score after ball update
                scoreSocket.emit("liveScore", { eventId: gmid });
            });
        } else {
            // Live match score events
            scoreSocket.on("summary_snapshot", (data) => {
                console.log("📊 Live match summary_snapshot received, eventId:", data?.eventId);
                if (data && data.eventId == gmid) {
                    processScoreData(data);
                }
            });
            
            scoreSocket.on("summary_update", (data) => {
                console.log("📊 Live match summary_update received, eventId:", data?.eventId);
                if (data && data.eventId == gmid) {
                    processScoreData(data);
                }
            });
        }

        // Debug all events
        scoreSocket.onAny((eventName, ...args) => {
            const relevantEvents = ['liveScore', 'liveScore2', 'match_data', 'summary_snapshot', 'summary_update', 'eventGetLiveEventsFancyData', 'ball_update'];
            if (!relevantEvents.includes(eventName)) {
                console.log(`📡 Score event: ${eventName}`, args[0]);
            }
        });
    } else {
        console.log("⚠️ No gmid provided - score updates disabled");
    }

    // ========== 3. CLEANUP ==========
    return () => {
        if (oddsSocketRef.current) {
            console.log("🔌 Disconnecting odds socket");
            oddsSocketRef.current.disconnect();
        }
        
        if (scoreSocketRef.current && gmid) {
            console.log(`📡 Disconnecting score socket for ${gmid}`);
            try {
                if (isVirtualMatch) {
                    scoreSocketRef.current.emit("leave_match", gmid);
                } else {
                    scoreSocketRef.current.emit("unsubscribe_event", {
                        eventId: gmid.toString(),
                        providerId: "1"
                    });
                }
            } catch (e) {
                console.log("Error unsubscribing:", e.message);
            }
            scoreSocketRef.current.disconnect();
        }
        
        if (updateTimerRef.current) {
            clearTimeout(updateTimerRef.current);
        }
    };
}, [marketId, gmid, isVirtualMatch]);

    useEffect(() => {
    if (showBetSlip && selectedBet) {
        setBetStake('');
    }
}, [showBetSlip, selectedBet]);


    const processIncomingData = useCallback((data) => {
        const updates = {};
        
        if (data.cricket && data.cricket.length > 0) {
            data.cricket.forEach(market => {
                const marketName = market.marketName || '';
                
                if (marketName === "Match Odds") {
                    if (market.runners) {
                        updates.matchOdds = market.runners;
                    }
                    
                    if (market.bookmaker && market.bookmaker.length > 0) {
                        updates.bookmakerMarkets = market.bookmaker;
                    }
                    
                    if (market.bookmaker_tied && market.bookmaker_tied.length > 0) {
                        updates.bookmakerTiedMarkets = market.bookmaker_tied;
                    }
                } 
                else if (marketName === "Tied Match") {
                    updates.tiedMatchMarkets = {
                        marketInfo: {
                            marketId: market.marketId,
                            marketName: market.marketName,
                            status: market.status,
                            inplay: market.inplay,
                            maxBet: market.maxBet,
                            min: market.min,
                            totalMatched: market.totalMatched
                        },
                        runners: market.runners ? market.runners.map(runner => ({
                            name: runner.name,
                            status: runner.status,
                            selectionId: runner.selectionId,
                            back: runner.back ? runner.back.map(b => ({
                                price: b.price,
                                size: b.size
                            })) : [],
                            lay: runner.lay ? runner.lay.map(l => ({
                                price: l.price,
                                size: l.size
                            })) : [],
                            max: runner.max,
                            min: runner.min
                        })) : []
                    };
                }
            });
        }

        if (data.session && data.session[0]?.value?.session) {
            updates.sessionMarkets = data.session[0].value.session.map(market => ({
                ...market,
                backPrice1: market.BackPrice1,
                backPrice2: market.BackPrice2,
                backPrice3: market.BackPrice3,
                layPrice1: market.LayPrice1,
                layPrice2: market.LayPrice2,
                layPrice3: market.LayPrice3,
                backSize1: market.BackSize1,
                backSize2: market.BackSize2,
                backSize3: market.BackSize3,
                laySize1: market.LaySize1,
                laySize2: market.LaySize2,
                laySize3: market.LaySize3
            }));
        }

        if (data.bm1 && data.bm1[0]?.value?.session) {
            updates.bm1Markets = data.bm1[0].value.session.map(market => ({
                ...market,
                backPrice1: market.BackPrice1,
                backPrice2: market.BackPrice2,
                backPrice3: market.BackPrice3,
                layPrice1: market.LayPrice1,
                layPrice2: market.LayPrice2,
                layPrice3: market.LayPrice3,
                backSize1: market.BackSize1,
                backSize2: market.BackSize2,
                backSize3: market.BackSize3,
                laySize1: market.LaySize1,
                laySize2: market.LaySize2,
                laySize3: market.LaySize3,
                SelectionId: market.SelectionId,
                selectionId: market.SelectionId
            }));
        }

        if (Object.keys(updates).length > 0) {
            batchUpdate(updates);
        }
    }, [batchUpdate]);

    // ... (rest of your formatting and utility functions remain the same)
    const formatOdds = useCallback((odds) => {
        if (!odds || odds === 0 || odds === '0') return '-';
        const num = parseFloat(odds);
        if (num >= 100) {
            return Math.round(num).toString();
        }
        return num.toFixed(2);
    }, []);

    const formatSize = useCallback((size) => {
        if (!size || size === 0) return '-';
        if (size >= 1000000) return `${(size/1000000).toFixed(1)}M`;
        if (size >= 1000) return `${(size/1000).toFixed(1)}K`;
        return size.toString();
    }, []);

    const formatCurrency = useCallback((amount) => {
        if (!amount && amount !== 0) return '₹0';
        return `₹${amount.toLocaleString('en-IN', { maximumFractionDigits: 2 })}`;
    }, []);

    const isMarketActive = useCallback((market) => {
        if (!market) return false;
        const status = market.GameStatus || market.status || '';
        return status !== 'SUSPENDED' && status !== 'Ball Running' && status !== 'Suspended';
    }, []);

    const getMarketStatus = useCallback((market) => {
        if (!market) return null;
        const status = market.GameStatus || market.status || '';
        if (status === 'SUSPENDED' || status === 'Suspended') {
            return <span className="status-badge suspended">SUSPENDED</span>;
        }
        if (status === 'Ball Running') {
            return <span className="status-badge ball-running">BALL RUNNING</span>;
        }
        return null;
    }, []);
const handleBetClick = useCallback((type, marketName, runnerName, price, size, marketType, market) => {
    if (!isMarketActive(market)) {
        toast.error(`Market is ${market?.GameStatus || 'inactive'}`, {
            duration: 3000,
            position: 'top-right'
        });

        return;
    }

    let betType = type;

    if (marketType === 'session') {
        betType = type === 'back' ? 'yes' : 'no';
    }

    let targetValue = null;
    let comparison = 'none';

    if (marketType === 'session') {
        // Check for over-based pattern
        const overMatch = market.RunnerName?.match(/(\d+(?:\.\d+)?)\s*over/);

        if (overMatch) {
            targetValue = parseFloat(overMatch[1]);
            comparison = betType === 'yes' ? 'above' : 'below';
        }

        // NEW: Check for wicket-based pattern
        const wicketMatch = market.RunnerName?.match(
            /fall\s+of\s+\d+(?:st|nd|rd|th)?\s*wkt/i
        );

        if (wicketMatch) {
            targetValue = null;
            comparison = betType === 'yes' ? 'above' : 'below';
        }
    }

    let currentPrice = price;

    if (type === 'back' || type === 'yes') {
        currentPrice =
            market.back?.[0]?.price ||
            market.BackPrice1 ||
            price;
    } else {
        currentPrice =
            market.lay?.[0]?.price ||
            market.LayPrice1 ||
            price;
    }

    let selectionId = '';

    if (marketType === 'session') {
        /*
         * Session markets can arrive in different formats:
         *
         * 1. marketId
         * 2. "state.marketId"
         * 3. SelectionId
         * 4. selectionId
         * 5. id
         *
         * Always use the actual numeric market/selection ID.
         * NEVER fall back to runnerName here.
         */
        const rawSelectionId =
            market["state.marketId"] ??
            market.marketId ??
            market.SelectionId ??
            market.selectionId ??
            market.id;

        if (
            rawSelectionId !== undefined &&
            rawSelectionId !== null &&
            rawSelectionId !== ''
        ) {
            selectionId = rawSelectionId.toString();
        }
    }
    else if (marketType === 'bookmaker2') {
        if (market.SelectionId) {
            selectionId = market.SelectionId.toString();
        } else if (market.selectionId) {
            selectionId = market.selectionId.toString();
        } else if (market.id) {
            selectionId = market.id.toString();
        } else {
            selectionId = runnerName.replace(/\./g, '').trim();
        }
    }
    else if (marketType === 'bookmaker_tied') {
        selectionId = market.selectionId?.toString() || market.id?.toString();
    }
    else if (marketType === 'bookmaker') {
        selectionId = market.selectionId?.toString() || market.id?.toString();
    }
    else {
        selectionId =
            market.SelectionId ||
            market.selectionId ||
            market.id;
    }

    const minBet = market.Min || market.min || 100;
    const maxBet = market.Max || market.max;

    const matchName = `${teams.team1} vs ${teams.team2}`;

    setSelectedBet({
        type: betType,
        marketName,
        marketType,
        runner: runnerName,
        selectionId: selectionId,
        price: currentPrice,
        size,
        marketId: marketId,
        targetValue,
        gmid: gmid,
        comparison,
        marketData: market,
        minBet,
        maxBet,
        matchName: matchName
    });

    setShowBetSlip(true);
}, [isMarketActive, marketId]);

    // ... (rest of the placeBet function and other functions remain the same)
    const placeBet = async () => {
        if (!betStake || parseFloat(betStake) <= 0) {
            
            toast.error('Please enter a valid stake', {
                duration: 3000,
                position: 'top-right'
            });

            return;
        }

        setIsPlacingBet(true);

        try {
            const stakeNum = parseFloat(betStake);
            const marketData = selectedBet.marketData;
            
            const minBet = marketData?.Min || marketData?.min || 100;
            if (stakeNum < minBet) {
        
                toast.error(`Minimum bet for this market is ₹${minBet}`, {
                    duration: 3000,
                    position: 'top-right'
                });
                
                setIsPlacingBet(false);
                return;
            }
            
            const maxBet = marketData?.Max || marketData?.max;
            if (maxBet && stakeNum > maxBet) {
                
                toast.error(`Maximum bet for this market is ₹${maxBet}`, {
                    duration: 3000,
                    position: 'top-right'
                });
                
                setIsPlacingBet(false);
                return;
            }
            const matchName = `${teams.team1} vs ${teams.team2}`;
            
            const betData = {
                marketId: selectedBet.marketId?.toString(),
                marketName: selectedBet.marketName || 'Match Odds',
                marketType: selectedBet.marketType || 'match',
                selectionId: selectedBet.selectionId?.toString() || selectedBet.runner,
                selectionName: selectedBet.runner,
                betType: selectedBet.type,
                odds: selectedBet.price,
                stake: stakeNum,
                targetValue: selectedBet.targetValue,
                comparison: selectedBet.comparison,
                size: selectedBet.size,
                gmid: selectedBet.gmid,
                matchName: matchName
            };

            const response = await bettingService.placeBet(betData);
            
            if (response.success && response.data) {
                const formatNumber = (value) => {
                    if (value === null || value === undefined) return '0.00';
                    const num = parseFloat(value);
                    return isNaN(num) ? '0.00' : num.toFixed(2);
                };


                                const SuccessMessage = () => (
                    <div style={{ fontSize: '13px', lineHeight: '1.5' }}>
                        <strong style={{ fontSize: '14px' }}>✅ Bet placed successfully!</strong>
                    </div>
                );
                
             
                toast.success(<SuccessMessage />, {
                    duration: 3000,
                    position: 'top-center',
                    style: {
                        maxWidth: '350px',
                        padding: '12px'
                    }
                });

                
                try {
                    const statsResponse = await userDashboardAPI.getDashboardStats();
                    const exposureResponse = await bettingService.getUserExposure();
                    
                    let balance = 0;
                    if (statsResponse?.success && statsResponse?.data) {
                        balance = parseFloat(statsResponse.data.balance) || 0;
                    }
                    
                    let exposure = 0;
                    if (exposureResponse?.data) {
                        if (exposureResponse.data.totalExposure !== undefined) {
                            exposure = parseFloat(exposureResponse.data.totalExposure);
                        } else if (exposureResponse.data.exposure !== undefined) {
                            exposure = parseFloat(exposureResponse.data.exposure);
                        }
                    }
                    
                    setUserStats({
                        balance,
                        exposure,
                        availableBalance: balance - exposure
                    });
                } catch (statsError) {
                    console.error('Error refreshing stats after bet:', statsError);
                }
                
                await fetchCurrentMatchBets();
                
                setShowBetSlip(false);
                setBetStake('');
                setSelectedBet(null);
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            console.error('Bet placement error details:', error);
            
            let errorMessage = 'Failed to place bet. ';
            
            if (error.response) {
                if (error.response.data?.message) {
                    errorMessage = error.response.data.message;
                } else {
                    errorMessage += error.response.data?.message || JSON.stringify(error.response.data);
                }
            } else if (error.request) {
                errorMessage += 'No response from server. Please check your connection.';
            } else {
                errorMessage += error.message;
            }
            
            toast.error(`❌ ${errorMessage}`, {
                duration: 3000,
                position: 'top-right'
            });

        } finally {
            setIsPlacingBet(false);
            
        }
    };

    const teams = useMemo(() => {
    // First preference: Match Odds runners
    if (matchState.matchOdds?.length >= 2) {
        return {
            team1: matchState.matchOdds[0]?.name || 'Team 1',
            team2: matchState.matchOdds[1]?.name || 'Team 2'
        };
    }

    // Fallback: Bookmaker names
    if (matchState.bookmakerMarkets?.length >= 2) {
        return {
            team1: matchState.bookmakerMarkets[0]?.name || 'Team 1',
            team2: matchState.bookmakerMarkets[1]?.name || 'Team 2'
        };
    }

    return {
        team1: 'Team 1',
        team2: 'Team 2'
    };
}, [matchState.matchOdds, matchState.bookmakerMarkets]);

    const bookmakerPnL = useMemo(() => 
        calculateBookmakerPnL(currentMatchBets.bookmaker), 
        [currentMatchBets.bookmaker, calculateBookmakerPnL]
    );
    
    const bookmaker2PnL = useMemo(() => 
        calculateBookmakerPnL(currentMatchBets.bookmaker2), 
        [currentMatchBets.bookmaker2, calculateBookmakerPnL]
    );
    
    const bookmakerTiedPnL = useMemo(() => 
        calculateBookmakerPnL(currentMatchBets.bookmakerTied), 
        [currentMatchBets.bookmakerTied, calculateBookmakerPnL]
    );

    const sessionBets = useMemo(() => 
        calculateSessionPnL(currentMatchBets.session),
        [currentMatchBets.session, calculateSessionPnL]
    );

        const tabBarRef = useRef(null);

    // This effect physically moves the TV container in the DOM when TV is clicked
    useEffect(() => {
        const tvContainer = document.querySelector('.mobile-show-tv .dash-right-col');
        const tabBar = tabBarRef.current;

        if (tvContainer && tabBar) {
            // If we are in TV mode, move the TV container to sit exactly after the tab bar
            if (mobileTab === 'tv') {
                // Only move if it isn't already in the right place
                if (tvContainer.parentNode !== tabBar.parentNode) {
                    tabBar.parentNode.insertBefore(tvContainer, tabBar.nextSibling);
                }
            } 
        }
    }, [mobileTab]);



    return (
        <div className="unified-match-details">
           
            <header className="ce-header">
                
                {/* MOBILE HAMBURGER (Left) - Only shows on mobile via CSS */}
            <button className="mobile-hamburger" onClick={() => {
                const toggle = document.getElementById('sidebar-toggle');
                if(toggle) toggle.checked = !toggle.checked;
            }}>
                ☰
            </button>

                {/* LOGO (Center-Left) */}
                <div className="ce-logo-wrap">
                    <a href="#" onClick={(e) => { e.preventDefault(); navigate('/user/dashboard'); }}>
                        <img src={logo} alt="Wazirbook" className="ce-logo" />
                    </a>
                </div>

                {/* USER DETAILS (Right) */}

                {/* =========================================================== */}
                {/* DESKTOP USER DETAILS - YOUR EXACT ORIGINAL CODE, UNTOUCHED  */}
                {/* =========================================================== */}
                <div className="ce-user-details desktop-only">
                    <div className="ce-user-balance">
                        <div className="ce-balance-item"><span>Balance:</span><b>{formatCurrency(userStats.balance)}</b></div>
                        <div className="ce-balance-item"><span>Exp:</span><b>{formatCurrency(userStats.exposure)}</b></div>
                    </div>
                    <div className="ce-user" ref={dropdownRef}>
                        <div className="ce-user-name" onClick={() => setActiveDropdown(!activeDropdown)}>
                            <span>{user?.username}</span>
                            <img src={drop} alt="dropdown" className="ce-dropdown-icon" />
                        </div>
                        {activeDropdown && (
                            <div className="ce-dropdown">
                                <button onClick={() => { setActiveDropdown(false); navigate('/user/account-statement'); }}>Account History</button>
                                <button onClick={() => { setActiveDropdown(false); navigate('/user/current-bets'); }}>Current Bets</button>
                                <button onClick={() => { setActiveDropdown(false); navigate('/user/change-password'); }}>Change Password</button>
                                <button className="ce-logout" onClick={handleLogout}>Logout</button>
                            </div>
                        )}
                    </div>
                </div>

                {/* =========================================================== */}
                {/* MOBILE USER DETAILS - BRAND NEW STRUCTURE                  */}
                {/* =========================================================== */}
                <div className="ce-user-details mobile-only">
                    {/* Row 1: Balance (Top) */}
                    <div className="mobile-balance-row">
                        <span>Balance:</span> <b>{formatCurrency(userStats.balance)}</b>
                    </div>
                    
                    {/* Row 2: Exposure + Username (Side by Side exactly as you asked) */}
                    <div className="mobile-exposure-user-row">
                        <div className="mobile-exp-block">
                            <span>Exp:</span> <b>{formatCurrency(userStats.exposure)}</b>
                        </div>
                        <div className="mobile-user-block" ref={dropdownRef}>
                            <div className="ce-user-name" onClick={() => setActiveDropdown(!activeDropdown)}>
                                <span>{user?.username}</span>
                                <img src={drop} alt="dropdown" className="ce-dropdown-icon" />
                            </div>
                            {activeDropdown && (
                                <div className="ce-dropdown">
                                    <button onClick={() => { setActiveDropdown(false); navigate('/user/account-statement'); }}>Account History</button>
                                    <button onClick={() => { setActiveDropdown(false); navigate('/user/current-bets'); }}>Current Bets</button>
                                    <button onClick={() => { setActiveDropdown(false); navigate('/user/change-password'); }}>Change Password</button>
                                    <button className="ce-logout" onClick={handleLogout}>Logout</button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

            </header>

            <div className="header-bottom">
                <nav className="navbar navbar-expand">
                    <ul className="navbar-nav">

                        <li className="nav-item">
                            <span className="nav-link" 
                            onClick={() => navigate("/user/dashboard")}>
                                Home
                            </span>
                        </li>

                        <li className="nav-item">
                            <span className="nav-link" onClick={() => toast.error("Game Locked")}>
                                Lottery
                            </span>
                        </li>

                        <li className="nav-item">
                            <span
                                className="nav-link active"
                                onClick={() => navigate("/user/dashboard")}>
                                Cricket
                            </span>
                        </li>

                        <li className="nav-item">
                            <span className="nav-link" onClick={() => toast.error("Game Locked")}>
                                Tennis
                            </span>
                        </li>

                        <li className="nav-item">
                            <span className="nav-link" onClick={() => toast.error("Game Locked")}>
                                Football
                            </span>
                        </li>

                        <li className="nav-item">
                            <span className="nav-link" onClick={() => toast.error("Game Locked")}>
                                Table Tennis
                            </span>
                        </li>

                        <li className="nav-item">
                            <span className="nav-link" onClick={() => toast.error("Game Locked")}>
                                Baccarat
                            </span>
                        </li>

                        <li className="nav-item">
                            <span className="nav-link" onClick={() => toast.error("Game Locked")}>
                                32 Cards
                            </span>
                        </li>

                        <li className="nav-item">
                            <span className="nav-link" onClick={() => toast.error("Game Locked")}>
                                Teenpatti
                            </span>
                        </li>

                        <li className="nav-item">
                            <span className="nav-link" onClick={() => toast.error("Game Locked")}>
                                Poker
                            </span>
                        </li>

                        <li className="nav-item">
                            <span className="nav-link" onClick={() => toast.error("Game Locked")}>
                                Lucky 7
                            </span>
                        </li>

                        <li className="nav-item">
                <span
                    className="nav-link ce-crash-link"
                    onClick={() => toast.error("Game Locked")}
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 457.6 277.4"
                        className="ce-crash-icon"
                    >
                    <g><path class="cls-1" d="M61.85,273.4c-1.8-3.5-2.3-3.9-4-3-3.2,1.7-5.5,1.1-9-2.5l-3.3-3.4,4.4-1.9c2.4-1.1,8-2.2,12.4-2.6,27.1-2.5,84.1-19.2,161-47.1,32.1-11.7,80.4-30.1,81.3-31,1.2-1.2-1-1.5-11.9-1.7-10.6-.2-11.7,0-16.5,2.4-13.1,6.8-74.6,31.2-92.8,36.7l-6.9,2.1-6.4-5-6.5-4.9-3.6,1.5c-21.3,9-88,36.4-89.2,36.6-1,.2-1.6-.6-1.8-2.3-.3-2.4.5-3,7.8-6.9,4.5-2.3,7.9-4.5,7.5-4.8-.3-.4-4.3-.9-8.9-1.3-9.7-.8-17.3-4-28.2-11.9-4.8-3.5-7.8-5-10-5-4.3,0-6.4.9-6.4,2.7,0,.8,6.8,8.7,15.1,17.6,13,13.7,14.9,16.2,13.3,16.8-3.7,1.5-4.8.8-16.3-10.3-6.4-6.2-14.6-14.2-18.3-17.7l-6.7-6.5-8.8,4.2-8.8,4.2-.3-3.4c-.2-2,.2-4.4.8-5.5s6.5-4.8,13.1-8.2c11.8-6,14.2-8,12.2-10-.7-.7-4.1.5-10.2,3.5l-9.1,4.6v-2.5c0-2,1.4-3.3,7.7-7,10.3-6,17.3-8.1,22.3-6.6,2.1.6,10.7,6.3,19.1,12.6,19,14.3,29.4,19.9,35.9,19.2,5.3-.5,34-13.7,61.9-28.5,18.3-9.7,21.6-12.1,19.5-14.2-.7-.7-7.1,1.8-21.4,8.5-14.7,7-20.5,9.3-21.1,8.4-1.2-2-.1-3.3,5.6-6.3,3-1.6,5.5-3.4,5.5-4,0-.7-1.3-2.5-2.8-4l-2.9-2.7-19.8,9.6c-10.9,5.2-20,9.3-20.2,9.1-.8-.7,2.5-12.8,3.8-14.1.8-.8,9.5-5.6,19.4-10.8,17.7-9.4,18-9.6,17.8-12.7,0-1.7-.4-3.4-.7-3.7s-3.9.9-8,2.7l-7.4,3.3-8.9-9.3c-4.8-5.1-8.9-9.6-9.1-10-.5-1.4,8.8-7.9,14.6-10.1,10.4-4,10.9-3.9,118.5,11.3,35.6,5,65.5,9.7,66.5,10.4,1.6,1.1,1.6,1.4-.1,4.8l-1.7,3.7,2.8,1c1.5.5,5.8,2.1,9.5,3.6l6.9,2.5,10.1-4.3c12.4-5.2,32.9-15.6,45.6-23.2l9.4-5.5,3.2,2.4c3.2,2.4,6.9,3.1,7.9,1.6.3-.5-2.5-6.9-6.3-14.3-3.7-7.4-8.7-18.4-11-24.4-2.4-6.1-4.8-11.6-5.4-12.4-.9-1-3.3-1.2-10.7-.8-10.8.5-18.1,2.6-42,12-15.4,6-67.7,31.5-70.6,34.4-1.3,1.4-3.4,1.4-19.2-.1-9.7-.9-18-1.6-18.4-1.6-1.4,0-.8-5.5,1.1-9.7,1.6-3.4,3.9-5.4,14-12.1,14.3-9.5,28.2-16.5,37.4-18.9l6.5-1.7,9.9,3.9c14.3,5.6,16.3,5.6,39.8-1,38.2-10.6,43.5-11.8,52.2-11.9,8-.1,8.3,0,11.6,3.3,2.6,2.5,5.7,8.3,12,23,4.7,10.8,9,21.3,9.7,23.5,1.7,5.4.8,11.9-2.4,16-6.7,8.8-38,25.2-82.1,42.8-22.8,9.1-61.8,21.9-162.5,53.3-31.1,9.7-64.7,20.3-74.6,23.6-10,3.2-18.9,5.9-19.8,5.9-.8,0-2.5-1.8-3.6-4ZM291.35,168.4c3.8-2.3,7.1-6.9,5.8-8-.6-.5-144.9-20.8-158.8-22.3-1.2-.1-2,.4-2,1.3,0,1.2,15.5,4.6,72,16.1,39.6,8.1,73.7,14.7,75.9,14.8,2.3.1,5.2-.7,7.1-1.9h0ZM247.65,122c4.2-2.3,11.2-5.8,15.4-7.7,4.3-1.9,7.8-3.7,7.8-4.1s-2.8-1.3-6.2-2c-7.7-1.7-13.7-.9-22.4,3.3-6.7,3.1-18.9,11.7-18.1,12.6.6.5,9.3,1.9,13.5,2.2,1.3,0,5.8-1.9,10-4.3h0ZM282.15,115.8c7.5-3.8,10.7-6,10.5-7.1-.4-2.1-18.3-9.2-23.4-9.3-2.2,0-4.9.6-6,1.4q-2.1,1.6,10.4,6.5c2.6,1,4.8,2.3,5,2.9s-1.9,2.2-4.7,3.6c-5.5,2.8-6.6,4-5.7,6.1.8,2.3,2.3,1.9,13.9-4.1h0Z"></path><path class="cls-1" d="M440.55,196.2c-6.8-10.1-13.5-20.3-14.9-22.8-1.5-2.5-5.5-14.1-9.1-25.7l-6.5-21.3,5.1-5c2.7-2.8,5.1-4.9,5.2-4.8.1.2,5.2,9.4,11.4,20.6,11.9,21.3,15.8,31,23.1,58,3.3,11.9,3.3,12.3,1.7,15.7-.9,1.9-2.1,3.5-2.6,3.5s-6.5-8.2-13.4-18.2h0ZM454.65,206.5c.2-1.9-.5-4.6-1.7-6.7-1.8-3.1-22-30.4-24.3-32.9-1.2-1.3-3,1.5-2.2,3.5,1.2,3.4,26,39.9,26.9,39.6.6-.1,1.1-1.7,1.3-3.5h0Z"></path><path class="cls-1" d="M295.35,148.3c-13.2-2.6-24.6-4.9-25.4-5.1-.8-.2,11.3-5.4,27-11.6l28.3-11.4,5.3,5.9c2.9,3.2,5.2,6.3,5.3,6.9,0,.6-2.3,5.5-5.1,10.8-4.8,9.1-5.2,9.6-8.2,9.5-1.8-.1-14-2.3-27.2-5h0Z"></path><path class="cls-1" d="M334.85,152.1c0-.2,1.6-3.6,3.6-7.5,1.9-4,4.1-9,4.9-11.1l1.3-3.8-5.3-6.9c-5.3-6.8-5.4-6.9-3.2-8.1,2-1.1,2.6-.8,6.2,3.2,2.2,2.5,4.3,4.5,4.6,4.5s1.7-3.9,3-8.7l2.4-8.8.3,4.9c.2,2.6-.2,8-.8,11.8l-1,7,5.1,6.4,5.1,6.4-2.7,1c-2.2.9-2.9.6-5-1.8-1.3-1.5-2.5-3-2.5-3.4-.1-2.3-1.9-.1-3.9,4.6-1.2,3-2.8,5.9-3.5,6.5-1.4,1.1-8.6,4.3-8.6,3.8h0Z"></path><path class="cls-1" d="M404.75,114.7c-7.2-16.1-7.3-16.4-5.8-17.5,1.5-1,21.2-.4,24.2.7.9.4,1.7,1.4,1.7,2.2,0,4.2-12.6,21.3-15.6,21.3-.9,0-2.8-2.9-4.5-6.7h0ZM414.15,104.7c4.8-2,8.7-4,8.7-4.4,0-1.2-4.4-1.9-13.2-1.9-8.2,0-8.8.1-8.8,2,0,2.4,2.7,8,3.8,8,.4,0,4.6-1.6,9.5-3.7Z"></path><path class="cls-1" d="M385.05,75.9c-10.7-19.1-14-27.3-20.7-51.6-4-14.3-4.3-18.7-1.6-22l1.9-2.3,14.8,22.3,14.8,22.3,7.6,24.2c4.2,13.2,7.4,24.2,7.1,24.3-.3.1-3.5.3-7.1.6l-6.5.4-10.3-18.2h0ZM391.85,46.5c0-1.5-23.2-37.5-26.1-40.6-1.3-1.3-2.9,1.2-2.9,4.7,0,2.5,8.8,15.4,22.3,32.7,4.6,6,6.7,7,6.7,3.2Z"></path></g>
                    </svg>

                    <span>Crash</span>
                </span>
                </li>

                    </ul>
                </nav>
            </div>
      
            <div className="main-content">
                    <input type="checkbox" id="sidebar-toggle" />

        {/* 2. Dark Overlay. Clicking it closes the menu automatically */}
        <label htmlFor="sidebar-toggle" className="sidebar-overlay"></label>
    
    <aside className="ce-sidebar">

{/* Racing Sports */}
<div className="ce-sidebar-title">
    <span>Racing Sports</span>
    <span>▲</span>
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    Horse Racing
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    Greyhound Racing
</div>


{/* Others */}
<div className="ce-sidebar-title">
    <span>Others</span>
    <span>▲</span>
</div>

<div className="ce-sidebar-item ce-blink-item" onClick={showLocked}>
    Our Casino
</div>

<div className="ce-sidebar-item ce-blink-item" onClick={showLocked}>
    Our VIP Casino
</div>

<div className="ce-sidebar-item ce-blink-item" onClick={showLocked}>
    Our Premium Casino
</div>

<div className="ce-sidebar-item ce-blink-item" onClick={showLocked}>
    Our Virtual
</div>
<div className="ce-sidebar-item" onClick={showLocked}>Live Casino</div>
<div className="ce-sidebar-item" onClick={showLocked}>Slot Game</div>
<div className="ce-sidebar-item" onClick={showLocked}>Fantasy Game</div>


{/* All Sports */}
<div className="ce-sidebar-title">
    <span>All Sports</span>
    <span>▲</span>
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Politics
</div>

<div className="ce-sidebar-item active">
    <span className="ce-plus">⊞</span>
    Cricket
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Football
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Tennis
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Table Tennis
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Badminton
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Esoccer
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Basketball
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Volleyball
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Snooker
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
   Ice Hockey
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    E Games
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Futsal
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Handball
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Kabaddi
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Golf
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Rugby League
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Boxing
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Beach Volleyball
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Mixed Martial Arts
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    MotoGP
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Chess
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Cycling
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Motorbikes
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Athletics
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Basketball 3X3
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Sumo
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Virtual Sports
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Motor Sports
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Baseball
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Rugby Union
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Darts
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    American Football
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Soccer
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Esports
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Boat Racing
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Wrestling
</div>

    </aside>
                
                            <div 
                    className={`three-col-dashboard ${
                        mobileTab === 'bets' ? 'mobile-show-bets' : 
                        mobileTab === 'tv' ? 'mobile-show-tv' : ''
                    }`}
                >

<div className="mobile-tab-bar">

    <button
        type="button"
        className={`mobile-tab-btn ${
            mobileTab === 'odds' ? 'active' : ''
        }`}
        onClick={() => setMobileTab('odds')}
    >
        ODDS
    </button>

    <button
        type="button"
        className={`mobile-tab-btn ${
            mobileTab === 'bets' ? 'active' : ''
        }`}
        onClick={() => setMobileTab('bets')}
    >
        MATCHED BET (
        {currentMatchBets.bookmaker.length +
            currentMatchBets.bookmaker2.length +
            currentMatchBets.bookmakerTied.length +
            currentMatchBets.session.length}
        )
    </button>

    <button
        type="button"
        className={`mobile-tab-btn ${
            mobileTab === 'tv' ? 'active' : ''
        }`}
        onClick={() => setMobileTab('tv')}
    >
        <i className="fas fa-tv"></i>
    </button>

</div>

<div className="tv-portal-anchor"></div>

                    <div className="dash-left-col">
                        
                        
          
                    </div>

                    <div className="dash-center-col">
                            

                           {gmid && (
                                <div className="live-scoreboard-embed">
                                    <iframe
                                        ref={scoreboardFrameRef}
                                        title="Live cricket scoreboard"
                                        src={`${SCOREBOARD_ORIGIN}/embed/${encodeURIComponent(gmid)}?theme=dark`}
                                        loading="lazy"
                                        referrerPolicy="strict-origin-when-cross-origin"
                                        scrolling="no"
                                        onLoad={handleScoreboardLoad}
                                        style={scoreboardHeight ? { height: `${scoreboardHeight}px` } : undefined}
                                    />
                                </div>
                            )}

                            <div className="markets-grid">
                                            {/* 1. Match Odds Section */}
                             

                                    {/* 2. Bookmaker Markets */}
                                    <h2 className="section-title">Bookmaker</h2>
<div className="bookmaker-grid">

<div className="bookmaker-header">

    {/* Team + B1 + B2 */}
    <div className="bookmaker-minmax">
        Min: {matchState.bookmakerMarkets?.[0]?.minBet || 100}
        {" | "}
        Max: {matchState.bookmakerMarkets?.[0]?.maxBet || 50000}
    </div>

    {/* BACK = B3 */}
    <div className="bookmaker-back-header">
        Back
    </div>

    {/* LAY = L1 */}
    <div className="bookmaker-lay-header">
        Lay
    </div>

    {/* L2 */}
    <div className="bookmaker-empty-header"></div>

    {/* L3 */}
    <div className="bookmaker-empty-header"></div>

</div>


    {/* =====================================================
        BOOKMAKER MARKETS
        ===================================================== */}
    {matchState.bookmakerMarkets.map((market, idx) => {

        const normalize = (name) =>
            name?.toString()
                .replace(/\./g, '')
                .replace(/\s+/g, '')
                .trim()
                .toLowerCase();

        const teamAName = normalize(
            bookmakerPosition?.teamA?.name
        );

        const marketName = normalize(
            market.name
        );

        // Check whether this is Team A
        const isTeamA = teamAName === marketName;

        // Position
        let positionValue;

        if (isTeamA) {
            positionValue =
                bookmakerPosition?.summary?.ifTeamAWins;
        } else {
            positionValue =
                bookmakerPosition?.summary?.ifTeamBWins;
        }

        // Market active state
        const marketActive = isMarketActive(market);


        return (
<div
    key={idx}
    className={`bookmaker-market-row ${
        !marketActive ? 'bookmaker-row-suspended' : ''
    }`}
>
    {/* Team */}

    <div className="bookmaker-team">
        <div className="bookmaker-team-name">
            {market.name}
        </div>

        <div className="bookmaker-position">
            <span
                className={`position-value ${
                    positionValue >= 0
                        ? 'positive'
                        : 'negative'
                }`}
            >
                {positionValue > 0 ? '+' : ''}
                ₹{(positionValue || 0).toFixed(2)}
            </span>
        </div>
    </div>

    {/* B1 */}
    <div className="bookmaker-odds empty-back">
        -
    </div>

    {/* B2 */}
    <div className="bookmaker-odds empty-back">
        -
    </div>

    {/* B3 */}
    {market.back && market.back[0]?.price > 0 ? (
        <button
            type="button"
            className={`bookmaker-odds bookmaker-back ${
                !marketActive
                    ? 'bookmaker-disabled'
                    : ''
            }`}
            onClick={() =>
                handleBetClick(
                    'back',
                    'Bookmaker',
                    market.name,
                    market.back[0].price,
                    market.back[0].size,
                    'bookmaker',
                    market
                )
            }
            disabled={!marketActive}
        >
            <span className="bookmaker-odds-price">
                {formatOdds(market.back[0].price)}
            </span>

            <span className="bookmaker-odds-size">
                {formatSize(market.back[0].size)}
            </span>
        </button>
    ) : (
        <div className="bookmaker-odds empty-back">
            -
        </div>
    )}

    {/* L1 */}
    {market.lay && market.lay[0]?.price > 0 ? (
        <button
            type="button"
            className={`bookmaker-odds bookmaker-lay ${
                !marketActive
                    ? 'bookmaker-disabled'
                    : ''
            }`}
            onClick={() =>
                handleBetClick(
                    'lay',
                    'Bookmaker',
                    market.name,
                    market.lay[0].price,
                    market.lay[0].size,
                    'bookmaker',
                    market
                )
            }
            disabled={!marketActive}
        >
            <span className="bookmaker-odds-price">
                {formatOdds(market.lay[0].price)}
            </span>

            <span className="bookmaker-odds-size">
                {formatSize(market.lay[0].size)}
            </span>
        </button>
    ) : (
        <div className="bookmaker-odds empty-lay">
            -
        </div>
    )}

    {/* L2 */}
    <div className="bookmaker-odds empty-lay">
        -
    </div>

    {/* L3 */}
    <div className="bookmaker-odds empty-lay">
        -
    </div>

    {/* SUSPENDED */}
    {!marketActive && (
        <div className="bookmaker-suspended-overlay">
            <span>SUSPENDED</span>
        </div>
    )}
</div>
        );
    })}




</div>


{matchState.bm1Markets.length > 0 && (
    <div className="market-section">

        <h2 className="section-title">
            Bookmaker 2
        </h2>

        <div className="bookmaker-grid">

            {matchState.bm1Markets.map((market, idx) => {

                /* =====================================================
                   NORMALIZE NAMES
                   ===================================================== */

                const normalize = (name) =>
                    name?.toString()
                        .replace(/\./g, '')
                        .replace(/\s+/g, '')
                        .trim()
                        .toLowerCase();

                const runnerName = normalize(
                    market.RunnerName
                );

                const teamAName = normalize(
                    bookmaker2Position?.teamA?.name
                );

                const isTeamA =
                    teamAName === runnerName;


                /* =====================================================
                   POSITION
                   ===================================================== */

                let positionValue = 0;

                if (isTeamA) {

                    positionValue =
                        bookmaker2Position?.summary?.ifTeamAWins || 0;

                } else {

                    positionValue =
                        bookmaker2Position?.summary?.ifTeamBWins || 0;

                }


                /* =====================================================
                   SELECTION ID
                   ===================================================== */

                const cleanName =
                    market.RunnerName
                        ?.replace(/\./g, '')
                        .trim() || '';

                const selectionIdValue =
                    market.SelectionId ||
                    market.selectionId ||
                    cleanName;


                /* =====================================================
                   MARKET ACTIVE
                   ===================================================== */

                const marketActive =
                    isMarketActive(market);


                return (

                   <div
                        key={idx}
                        className={`bookmaker-market-row ${
                            !marketActive ? 'bookmaker-row-suspended' : ''
                        }`}>

                        {/* =================================================
                            TEAM NAME + POSITION
                            ================================================= */}

                        <div className="bookmaker-team">

                            <div className="bookmaker-team-name">
                                {market.RunnerName}
                            </div>

                            <div className="bookmaker-position">

                                <span
                                    className={`position-value ${
                                        positionValue >= 0
                                            ? 'positive'
                                            : 'negative'
                                    }`}
                                >

                                    {positionValue > 0
                                        ? '+'
                                        : ''
                                    }

                                    ₹
                                    {Number(
                                        positionValue || 0
                                    ).toFixed(2)}

                                </span>

                            </div>

                        </div>


                        {/* =================================================
                            B1 - EMPTY
                            ================================================= */}

                        <div className="bookmaker-odds empty-back">
                            -
                        </div>


                        {/* =================================================
                            B2 - EMPTY
                            ================================================= */}

                        <div className="bookmaker-odds empty-back">
                            -
                        </div>


                        {/* =================================================
                            B3 - ACTUAL BACK
                            ================================================= */}

                        {market.BackPrice1 > 0 ? (

                            <button
                                type="button"
                                className={`bookmaker-odds bookmaker-back ${
                                    !marketActive
                                        ? 'bookmaker-disabled'
                                        : ''
                                }`}
                                onClick={() =>
                                    handleBetClick(
                                        'back',
                                        'Bookmaker 2',
                                        cleanName,
                                        market.BackPrice1,
                                        market.BackSize1,
                                        'bookmaker2',
                                        {
                                            ...market,
                                            selectionId:
                                                selectionIdValue,
                                            id:
                                                selectionIdValue,
                                            SelectionId:
                                                selectionIdValue
                                        }
                                    )
                                }
                                disabled={!marketActive}
                            >

                                <span className="bookmaker-odds-price">
                                    {formatOdds(
                                        market.BackPrice1
                                    )}
                                </span>

                                <span className="bookmaker-odds-size">
                                    {formatSize(
                                        market.BackSize1
                                    )}
                                </span>

                            </button>

                        ) : (

                            <div className="bookmaker-odds empty-back">
                                -
                            </div>

                        )}


                        {/* =================================================
                            L1 - ACTUAL LAY
                            ================================================= */}

                        {market.LayPrice1 > 0 ? (

                            <button
                                type="button"
                                className={`bookmaker-odds bookmaker-lay ${
                                    !marketActive
                                        ? 'bookmaker-disabled'
                                        : ''
                                }`}
                                onClick={() =>
                                    handleBetClick(
                                        'lay',
                                        'Bookmaker 2',
                                        cleanName,
                                        market.LayPrice1,
                                        market.LaySize1,
                                        'bookmaker2',
                                        {
                                            ...market,
                                            selectionId:
                                                selectionIdValue,
                                            id:
                                                selectionIdValue,
                                            SelectionId:
                                                selectionIdValue
                                        }
                                    )
                                }
                                disabled={!marketActive}
                            >

                                <span className="bookmaker-odds-price">
                                    {formatOdds(
                                        market.LayPrice1
                                    )}
                                </span>

                                <span className="bookmaker-odds-size">
                                    {formatSize(
                                        market.LaySize1
                                    )}
                                </span>

                            </button>

                        ) : (

                            <div className="bookmaker-odds empty-lay">
                                -
                            </div>

                        )}


                        {/* =================================================
                            L2 - EMPTY
                            ================================================= */}

                        <div className="bookmaker-odds empty-lay">
                            -
                        </div>


                        {/* =================================================
                            L3 - EMPTY
                            ================================================= */}

                        <div className="bookmaker-odds empty-lay">
                            -
                        </div>

                        {!marketActive && (
                        <div className="bookmaker-suspended-overlay">
                            <span>SUSPENDED</span>
                        </div>)}

                    </div>

                );

            })}

        </div>

    </div>
)}



                                            {/* 4. Bookmaker Tied Markets */}
                                            {matchState.bookmakerTiedMarkets && matchState.bookmakerTiedMarkets.length > 0 && (
                                                <div className="market-section bookmaker-tied-section">
                                                    <h2 className="section-title">Bookmaker Tied</h2>
                                                    <div className="tied-match-table-container">
                                                        <table className="tied-match-table">
                                                            <thead>
                                                                <tr>
                                                                    <th className="max-column">Max: 1</th>
                                                                    <th colSpan="3" className="back-header">Back</th>
                                                                    <th colSpan="3" className="lay-header">Lay</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {matchState.bookmakerTiedMarkets.map((market, idx) => (
                                                                    <tr key={idx} className="runner-row">
                                                                        <td className="runner-name-cell">{market.name}</td>
                                                                        
                                                                        {/* Back Odds - 3 cells */}
                                                                        <td className="odds-cell">
                                                                            {market.back && market.back[0]?.price > 0 ? (
                                                                                <button 
                                                                                    className={`odds-button back-btn ${market.status === 'SUSPENDED' ? 'disabled' : ''}`}
                                                                                    onClick={() => handleBetClick('back', 'Bookmaker Tied', market.name, market.back[0]?.price, market.back[0]?.size, 'bookmaker_tied', market)}
                                                                                    disabled={market.status === 'SUSPENDED' || !market.back[0]?.price}
                                                                                >
                                                                                    <span className="odds-value">{formatOdds(market.back[0]?.price)}</span>
                                                                                    <span className="odds-size">{formatSize(market.back[0]?.size)}</span>
                                                                                </button>
                                                                            ) : (
                                                                                <span className="empty-odds">-</span>
                                                                            )}
                                                                        </td>
                                                                        <td className="odds-cell">
                                                                            {market.back && market.back[1]?.price > 0 ? (
                                                                                <button 
                                                                                    className={`odds-button back-btn ${market.status === 'SUSPENDED' ? 'disabled' : ''}`}
                                                                                    onClick={() => handleBetClick('back', 'Bookmaker Tied', market.name, market.back[1]?.price, market.back[1]?.size, 'bookmaker_tied', market)}
                                                                                    disabled={market.status === 'SUSPENDED' || !market.back[1]?.price}
                                                                                >
                                                                                    <span className="odds-value">{formatOdds(market.back[1]?.price)}</span>
                                                                                    <span className="odds-size">{formatSize(market.back[1]?.size)}</span>
                                                                                </button>
                                                                            ) : (
                                                                                <span className="empty-odds">-</span>
                                                                            )}
                                                                        </td>
                                                                        <td className="odds-cell">
                                                                            {market.back && market.back[2]?.price > 0 ? (
                                                                                <button 
                                                                                    className={`odds-button back-btn ${market.status === 'SUSPENDED' ? 'disabled' : ''}`}
                                                                                    onClick={() => handleBetClick('back', 'Bookmaker Tied', market.name, market.back[2]?.price, market.back[2]?.size, 'bookmaker_tied', market)}
                                                                                    disabled={market.status === 'SUSPENDED' || !market.back[2]?.price}
                                                                                >
                                                                                    <span className="odds-value">{formatOdds(market.back[2]?.price)}</span>
                                                                                    <span className="odds-size">{formatSize(market.back[2]?.size)}</span>
                                                                                </button>
                                                                            ) : (
                                                                                <span className="empty-odds">-</span>
                                                                            )}
                                                                        </td>
                                                                        
                                                                        {/* Lay Odds - 3 cells */}
                                                                        <td className="odds-cell">
                                                                            {market.lay && market.lay[0]?.price > 0 ? (
                                                                                <button 
                                                                                    className={`odds-button lay-btn ${market.status === 'SUSPENDED' ? 'disabled' : ''}`}
                                                                                    onClick={() => handleBetClick('lay', 'Bookmaker Tied', market.name, market.lay[0]?.price, market.lay[0]?.size, 'bookmaker_tied', market)}
                                                                                    disabled={market.status === 'SUSPENDED' || !market.lay[0]?.price}
                                                                                >
                                                                                    <span className="odds-value">{formatOdds(market.lay[0]?.price)}</span>
                                                                                    <span className="odds-size">{formatSize(market.lay[0]?.size)}</span>
                                                                                </button>
                                                                            ) : (
                                                                                <span className="empty-odds">-</span>
                                                                            )}
                                                                        </td>
                                                                        <td className="odds-cell">
                                                                            {market.lay && market.lay[1]?.price > 0 ? (
                                                                                <button 
                                                                                    className={`odds-button lay-btn ${market.status === 'SUSPENDED' ? 'disabled' : ''}`}
                                                                                    onClick={() => handleBetClick('lay', 'Bookmaker Tied', market.name, market.lay[1]?.price, market.lay[1]?.size, 'bookmaker_tied', market)}
                                                                                    disabled={market.status === 'SUSPENDED' || !market.lay[1]?.price}
                                                                                >
                                                                                    <span className="odds-value">{formatOdds(market.lay[1]?.price)}</span>
                                                                                    <span className="odds-size">{formatSize(market.lay[1]?.size)}</span>
                                                                                </button>
                                                                            ) : (
                                                                                <span className="empty-odds">-</span>
                                                                            )}
                                                                        </td>
                                                                        <td className="odds-cell">
                                                                            {market.lay && market.lay[2]?.price > 0 ? (
                                                                                <button 
                                                                                    className={`odds-button lay-btn ${market.status === 'SUSPENDED' ? 'disabled' : ''}`}
                                                                                    onClick={() => handleBetClick('lay', 'Bookmaker Tied', market.name, market.lay[2]?.price, market.lay[2]?.size, 'bookmaker_tied', market)}
                                                                                    disabled={market.status === 'SUSPENDED' || !market.lay[2]?.price}
                                                                                >
                                                                                    <span className="odds-value">{formatOdds(market.lay[2]?.price)}</span>
                                                                                    <span className="odds-size">{formatSize(market.lay[2]?.size)}</span>
                                                                                </button>
                                                                            ) : (
                                                                                <span className="empty-odds">-</span>
                                                                            )}
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                        
                                                      
                                                    </div>
                                                </div>
                                            )}

                                            {/* 5. Session Markets */}
{matchState.sessionMarkets.length > 0 && (
    <div className="market-section">

        {/* SECTION TITLE */}
        <h2 className="section-title">
            Over Sessions (
            {matchState.sessionMarkets.filter(m => isSessionMarketValid(m)).length}
            )
        </h2>

        {/* SESSION MARKET HEADER */}
<div className="session-market-header">

    <div className="session-header-empty"></div>

    <div className="session-header-no">
        No
    </div>

    <div className="session-header-yes">
        Yes
    </div>

</div>

        <div className="session-grid">

            {matchState.sessionMarkets
                .filter(market => isSessionMarketValid(market))
                .map((market, idx) => {

                    const selectionName = market.RunnerName;
                    const userBets = userSessionBets[selectionName];

                    // Get the max loss from API response
                    const lossAmount = userBets?.maxLoss || 0;

                    return (
                        <div
                            key={idx}
                            className={`market-card ${
                                !isMarketActive(market)
                                    ? 'session-market-suspended'
                                    : ''
                            }`}>

                            {/* MARKET NAME */}
                            <div className="market-title">
                                {market.RunnerName}
                            </div>

                            {/* LOSS */}
                            {lossAmount > 0 && (
                                <div className="loss-inline">
                                    -₹{lossAmount.toLocaleString()}
                                </div>
                            )}

                            {/* NO / YES */}
                            <div className="yesno-row">

                                {/* NO */}
                                <button
                                    className={`no-btn ${
                                        !isMarketActive(market) ? 'disabled' : ''
                                    }`}
                                    onClick={() =>
                                        handleBetClick(
                                            'lay',
                                            'Session',
                                            market.RunnerName,
                                            market.LayPrice1,
                                            market.LaySize1,
                                            'session',
                                            market
                                        )
                                    }
                                    disabled={
                                        !isMarketActive(market) ||
                                        !market.LayPrice1 ||
                                        market.LayPrice1 <= 0
                                    }
                                >
                                  

                                    <span className="value">
                                        {formatOdds(market.LayPrice1)}
                                    </span>

                                    <span className="size">
                                        {formatSize(market.LaySize1)}
                                    </span>
                                </button>

                                {/* YES */}
                                <button
                                    className={`yes-btn ${
                                        !isMarketActive(market) ? 'disabled' : ''
                                    }`}
                                    onClick={() =>
                                        handleBetClick(
                                            'back',
                                            'Session',
                                            market.RunnerName,
                                            market.BackPrice1,
                                            market.BackSize1,
                                            'session',
                                            market
                                        )
                                    }
                                    disabled={
                                        !isMarketActive(market) ||
                                        !market.BackPrice1 ||
                                        market.BackPrice1 <= 0
                                    }
                                >
                                   

                                    <span className="value">
                                        {formatOdds(market.BackPrice1)}
                                    </span>

                                    <span className="size">
                                        {formatSize(market.BackSize1)}
                                    </span>
                                </button>

                            </div>

                            {!isMarketActive(market) && (
                            <div className="session-suspended-overlay">
                                <span>SUSPENDED</span>
                            </div>)}

                        </div>
                    );
                })}
        </div>

        {/* NO MARKETS */}
        {matchState.sessionMarkets.filter(
            m => isSessionMarketValid(m)
        ).length === 0 && (
            <div className="no-session-markets">
                No over sessions available at the moment
            </div>
        )}

    </div>
)}


                                            {matchState.tiedMatchMarkets && matchState.tiedMatchMarkets.runners && matchState.tiedMatchMarkets.runners.length > 0 && (
                                                <div className="market-section tied-match-section">
                                                    <h2 className="section-title">Tied Match</h2>
                                                    <div className="tied-match-table-container">
                                                        <table className="tied-match-table">
                                                            <thead>
                                                                <tr>
                                                                    <th className="max-column">Max: 1</th>
                                                                    <th colSpan="3" className="back-header">Back</th>
                                                                    <th colSpan="3" className="lay-header">Lay</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {/* Yes Row */}
                                                                {matchState.tiedMatchMarkets.runners.map((runner, idx) => {
                                                                    if (runner.name === "Yes") {
                                                                        return (
                                                                            <tr key={idx} className="runner-row">
                                                                                <td className="runner-name-cell">{runner.name}</td>
                                                                                
                                                                                {/* Back Odds - 3 cells */}
                                                                                {runner.back && runner.back.length > 0 ? (
                                                                                    <>
                                                                                        <td className="odds-cell">
                                                                                            <button 
                                                                                                className={`odds-button back-btn ${!isMarketActive(runner) ? 'disabled' : ''}`}
                                                                                                disabled={!isMarketActive(runner) || !runner.back[2]?.price}
                                                                                            >
                                                                                                <span className="odds-value">{formatOdds(runner.back[2]?.price)}</span>
                                                                                                <span className="odds-size">{formatSize(runner.back[2]?.size)}</span>
                                                                                            </button>
                                                                                        </td>
                                                                                        <td className="odds-cell">
                                                                                            <button 
                                                                                                className={`odds-button back-btn ${!isMarketActive(runner) ? 'disabled' : ''}`}
                                                                                                disabled={!isMarketActive(runner) || !runner.back[1]?.price}
                                                                                            >
                                                                                                <span className="odds-value">{formatOdds(runner.back[1]?.price)}</span>
                                                                                                <span className="odds-size">{formatSize(runner.back[1]?.size)}</span>
                                                                                            </button>
                                                                                        </td>
                                                                                        <td className="odds-cell">
                                                                                            <button 
                                                                                                className={`odds-button back-btn ${!isMarketActive(runner) ? 'disabled' : ''}`}
                                                                                                disabled={!isMarketActive(runner) || !runner.back[0]?.price}
                                                                                            >
                                                                                                <span className="odds-value">{formatOdds(runner.back[0]?.price)}</span>
                                                                                                <span className="odds-size">{formatSize(runner.back[0]?.size)}</span>
                                                                                            </button>
                                                                                        </td>
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <td className="odds-cell">-</td>
                                                                                        <td className="odds-cell">-</td>
                                                                                        <td className="odds-cell">-</td>
                                                                                    </>
                                                                                )}
                                                                                
                                                                                {/* Lay Odds - 3 cells */}
                                                                                {runner.lay && runner.lay.length > 0 ? (
                                                                                    <>
                                                                                        <td className="odds-cell">
                                                                                            <button 
                                                                                                className={`odds-button lay-btn ${!isMarketActive(runner) ? 'disabled' : ''}`}
                                                                                                disabled={!isMarketActive(runner) || !runner.lay[0]?.price}
                                                                                            >
                                                                                                <span className="odds-value">{formatOdds(runner.lay[0]?.price)}</span>
                                                                                                <span className="odds-size">{formatSize(runner.lay[0]?.size)}</span>
                                                                                            </button>
                                                                                        </td>
                                                                                        <td className="odds-cell">
                                                                                            <button 
                                                                                                className={`odds-button lay-btn ${!isMarketActive(runner) ? 'disabled' : ''}`}
                                                                                                disabled={!isMarketActive(runner) || !runner.lay[1]?.price}
                                                                                            >
                                                                                                <span className="odds-value">{formatOdds(runner.lay[1]?.price)}</span>
                                                                                                <span className="odds-size">{formatSize(runner.lay[1]?.size)}</span>
                                                                                            </button>
                                                                                        </td>
                                                                                        <td className="odds-cell">
                                                                                            <button 
                                                                                                className={`odds-button lay-btn ${!isMarketActive(runner) ? 'disabled' : ''}`}
                                                                                                disabled={!isMarketActive(runner) || !runner.lay[2]?.price}
                                                                                            >
                                                                                                <span className="odds-value">{formatOdds(runner.lay[2]?.price)}</span>
                                                                                                <span className="odds-size">{formatSize(runner.lay[2]?.size)}</span>
                                                                                            </button>
                                                                                        </td>
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <td className="odds-cell">-</td>
                                                                                        <td className="odds-cell">-</td>
                                                                                        <td className="odds-cell">-</td>
                                                                                    </>
                                                                                )}
                                                                            </tr>
                                                                        );
                                                                    }
                                                                    return null;
                                                                })}
                                                                
                                                                {/* No Row */}
                                                                {matchState.tiedMatchMarkets.runners.map((runner, idx) => {
                                                                    if (runner.name === "No") {
                                                                        return (
                                                                            <tr key={idx} className="runner-row">
                                                                                <td className="runner-name-cell">{runner.name}</td>
                                                                                
                                                                                {/* Back Odds - 3 cells */}
                                                                                {runner.back && runner.back.length > 0 ? (
                                                                                    <>
                                                                                        <td className="odds-cell">
                                                                                            <button 
                                                                                                className={`odds-button back-btn ${!isMarketActive(runner) ? 'disabled' : ''}`}
                                                                                                disabled={!isMarketActive(runner) || !runner.back[2]?.price}
                                                                                            >
                                                                                                <span className="odds-value">{runner.back[2]?.price ? formatOdds(runner.back[2]?.price) : '-'}</span>
                                                                                                <span className="odds-size">{runner.back[2]?.size ? formatSize(runner.back[2]?.size) : ''}</span>
                                                                                            </button>
                                                                                        </td>
                                                                                        <td className="odds-cell">
                                                                                            <button 
                                                                                                className={`odds-button back-btn ${!isMarketActive(runner) ? 'disabled' : ''}`}
                                                                                                disabled={!isMarketActive(runner) || !runner.back[1]?.price}
                                                                                            >
                                                                                                <span className="odds-value">{runner.back[1]?.price ? formatOdds(runner.back[1]?.price) : '-'}</span>
                                                                                                <span className="odds-size">{runner.back[1]?.size ? formatSize(runner.back[1]?.size) : ''}</span>
                                                                                            </button>
                                                                                        </td>
                                                                                        <td className="odds-cell">
                                                                                            <button 
                                                                                                className={`odds-button back-btn ${!isMarketActive(runner) ? 'disabled' : ''}`}
                                                                                                disabled={!isMarketActive(runner) || !runner.back[0]?.price}
                                                                                            >
                                                                                                <span className="odds-value">{runner.back[0]?.price ? formatOdds(runner.back[0]?.price) : '-'}</span>
                                                                                                <span className="odds-size">{runner.back[0]?.size ? formatSize(runner.back[0]?.size) : ''}</span>
                                                                                            </button>
                                                                                        </td>
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <td className="odds-cell">-</td>
                                                                                        <td className="odds-cell">-</td>
                                                                                        <td className="odds-cell">-</td>
                                                                                    </>
                                                                                )}
                                                                                
                                                                                {/* Lay Odds - 3 cells */}
                                                                                {runner.lay && runner.lay.length > 0 ? (
                                                                                    <>
                                                                                        <td className="odds-cell">
                                                                                            <button 
                                                                                                className={`odds-button lay-btn ${!isMarketActive(runner) ? 'disabled' : ''}`}
                                                                                                disabled={!isMarketActive(runner) || !runner.lay[0]?.price}
                                                                                            >
                                                                                                <span className="odds-value">{formatOdds(runner.lay[0]?.price)}</span>
                                                                                                <span className="odds-size">{formatSize(runner.lay[0]?.size)}</span>
                                                                                            </button>
                                                                                        </td>
                                                                                        <td className="odds-cell">
                                                                                            <button 
                                                                                                className={`odds-button lay-btn ${!isMarketActive(runner) ? 'disabled' : ''}`}
                                                                                                disabled={!isMarketActive(runner) || !runner.lay[1]?.price}
                                                                                            >
                                                                                                <span className="odds-value">{formatOdds(runner.lay[1]?.price)}</span>
                                                                                                <span className="odds-size">{formatSize(runner.lay[1]?.size)}</span>
                                                                                            </button>
                                                                                        </td>
                                                                                        <td className="odds-cell">
                                                                                            <button 
                                                                                                className={`odds-button lay-btn ${!isMarketActive(runner) ? 'disabled' : ''}`}
                                                                                                disabled={!isMarketActive(runner) || !runner.lay[2]?.price}
                                                                                            >
                                                                                                <span className="odds-value">{formatOdds(runner.lay[2]?.price)}</span>
                                                                                                <span className="odds-size">{formatSize(runner.lay[2]?.size)}</span>
                                                                                            </button>
                                                                                        </td>
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <td className="odds-cell">-</td>
                                                                                        <td className="odds-cell">-</td>
                                                                                        <td className="odds-cell">-</td>
                                                                                    </>
                                                                                )}
                                                                            </tr>
                                                                        );
                                                                    }
                                                                    return null;
                                                                })}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            )}
                            </div>

                    </div>

                    <div className="dash-right-col">

                        {/* 1. LIVE TV SECTION - Only visible when mobileTab is 'tv' */}
                    {gmid && (
    <div className="tv-section desktop-tv-section">

        <div className={`tv-accordion-container ${showTV ? 'active' : ''}`}>

            <button
                className={`tv-toggle-header ${showTV ? 'active' : ''}`}
                onClick={() => setShowTV(!showTV)}
            >
                <span>Live Match</span>

                <span className="arrow-indicator">
                    {showTV ? '▲' : '▼'}
                </span>
            </button>

            <div className="tv-stream-content">

                <div className="tv-stream-wrapper">

                    <MatchTVStream
                        matchId={gmid}
                        matchName={`${teams.team1} vs ${teams.team2}`}
                    />

                </div>

            </div>

        </div>

    </div>
)}


{mobileTab === 'tv' && gmid &&
    ReactDOM.createPortal(
        <div className="tv-section mobile-tv-section">
            <div className="tv-stream-content">
                <div className="tv-stream-wrapper">
                    <MatchTVStream
                        matchId={gmid}
                        matchName={`${teams.team1} vs ${teams.team2}`}
                    />
                </div>
            </div>
        </div>,
        document.querySelector('.tv-portal-anchor')
    )
}


                        


{showBetSlip && selectedBet && (
    <>
        {/* =====================================================
            DESKTOP BET SLIP
            Normal DOM position - stays inside your column
            ===================================================== */}
        <div className="desktop-bet-slip">
            <div className="bet-slip-responsive-wrapper">

                <div className="bet-slip-inline-container">

                    {/* HEADER */}
                    <div className="bet-slip-header">
                        <h3 className="header-title">
                            Place Bet
                        </h3>
                    </div>

                    {/* HEADER TABLE */}
                    <div className="bet-slip-headertable">
                        <div>(Bet for)</div>
                        <div>Odds</div>
                        <div>Stake</div>
                        <div>Profit</div>
                    </div>

                    {/* BET DETAILS */}
                    <div
                        className={`bet-details ${
                            selectedBet.type === 'back' ||
                            selectedBet.type === 'yes'
                                ? 'is-back'
                                : 'is-lay'
                        }`}
                    >

                        <div className="detail-item">
                            <strong>
                                {selectedBet.runner}
                            </strong>
                        </div>

                        <div className="detail-item">
                            <strong>
                                {selectedBet.price}
                            </strong>
                        </div>

                        <input
                            type="number"
                            value={betStake}
                            onChange={(e) =>
                                setBetStake(e.target.value)
                            }
                            placeholder="₹ Amount"
                            min="100"
                            step="100"
                            disabled={isPlacingBet}
                            autoFocus
                        />

                        {betStake &&
                            parseFloat(betStake) >= 100 && (
                                <div className="bet-calculationxss">

                                    {selectedBet.marketType === 'match' ||
                                    selectedBet.marketType === 'tied' ? (

                                        selectedBet.type === 'back' ? (
                                            <strong>
                                                ₹
                                                {(
                                                    parseFloat(betStake) *
                                                    (selectedBet.price - 1)
                                                ).toFixed(2)}
                                            </strong>
                                        ) : (
                                            <strong>
                                                ₹{parseFloat(betStake)}
                                            </strong>
                                        )

                                    ) : selectedBet.marketType === 'bookmaker' ||
                                      selectedBet.marketType === 'bookmaker_tied' ||
                                      selectedBet.marketType === 'bookmaker2' ? (

                                        selectedBet.type === 'back' ? (
                                            <strong>
                                                ₹
                                                {(
                                                    (selectedBet.price * 0.01) *
                                                    parseFloat(betStake)
                                                ).toFixed(2)}
                                            </strong>
                                        ) : (
                                            <strong>
                                                ₹{parseFloat(betStake)}
                                            </strong>
                                        )

                                    ) : selectedBet.marketType === 'session' ? (

                                        selectedBet.type === 'yes' ||
                                        selectedBet.type === 'back' ? (
                                            <strong>
                                                ₹
                                                {(
                                                    parseFloat(betStake) *
                                                    (selectedBet.size / 100)
                                                ).toFixed(2)}
                                            </strong>
                                        ) : (
                                            <strong>
                                                ₹{parseFloat(betStake)}
                                            </strong>
                                        )

                                    ) : (
                                        <strong>
                                            ₹
                                            {(
                                                parseFloat(betStake) *
                                                selectedBet.price
                                            ).toFixed(2)}
                                        </strong>
                                    )}

                                </div>
                            )}

                    </div>

                    {/* BODY */}
                    <div
                        className={`bet-slip-body ${
                            selectedBet.type === 'back' ||
                            selectedBet.type === 'yes'
                                ? 'is-back'
                                : 'is-lay'
                        }`}
                    >

                        <div className="bet-input-group">

                            <label>
                                Stake (Min ₹100)
                            </label>

                            {/* QUICK STAKES */}
                            <div className="quick-stakes">

                                {[
                                    500,
                                    1000,
                                    5000,
                                    10000,
                                    25000,
                                    50000,
                                    75000,
                                    100000
                                ].map((amt) => (

                                    <button
                                        key={amt}
                                        onClick={() =>
                                            setBetStake((prev) =>
                                                String(
                                                    parseFloat(prev || 0) +
                                                    amt
                                                )
                                            )
                                        }
                                        disabled={isPlacingBet}
                                    >
                                        {amt >= 1000
                                            ? `${amt / 1000}K`
                                            : amt}
                                    </button>

                                ))}

                            </div>

                        </div>

                        {/* ACTIONS */}
                        <div className="bet-actions">

                            <button
                                className="reset"
                                onClick={() => {
                                    setBetStake('');
                                    setShowBetSlip(false);
                                    setSelectedBet(null);
                                }}
                                disabled={isPlacingBet}
                            >
                                Reset
                            </button>

                            <button
                                type="button"
                                className="place-bet-btn"
                                disabled={
                                    !betStake ||
                                    parseFloat(betStake) < 100 ||
                                    isPlacingBet
                                }
                                onClick={() => {

                                    // Start API request
                                    placeBet();

                                    // Close immediately
                                    setShowBetSlip(false);
                                    setBetStake('');
                                    setSelectedBet(null);
                                }}
                            >
                                {isPlacingBet
                                    ? 'Placing Bet...'
                                    : 'Place Bet'}
                            </button>

                        </div>

                    </div>

                </div>

            </div>
        </div>


        {/* =====================================================
            MOBILE BET SLIP
            Portal to body so it can overlay everything
            ===================================================== */}
        {ReactDOM.createPortal(
            <div className="mobile-bet-slip">

                <div className="bet-slip-responsive-wrapper">

                    <div className="bet-slip-inline-container">

                        {/* HEADER */}
                        <div className="bet-slip-header">
                            <h3 className="header-title">
                                Place Bet
                            </h3>
                        </div>

                        {/* HEADER TABLE */}
                        <div className="bet-slip-headertable">
                            <div>(Bet for)</div>
                            <div>Odds</div>
                            <div>Stake</div>
                            <div>Profit</div>
                        </div>

                        {/* BET DETAILS */}
                        <div
                            className={`bet-details ${
                                selectedBet.type === 'back' ||
                                selectedBet.type === 'yes'
                                    ? 'is-back'
                                    : 'is-lay'
                            }`}
                        >

                            <div className="detail-item">
                                <strong>
                                    {selectedBet.runner}
                                </strong>
                            </div>

                            <div className="detail-item">
                                <strong>
                                    {selectedBet.price}
                                </strong>
                            </div>

                            <input
                                type="number"
                                value={betStake}
                                onChange={(e) =>
                                    setBetStake(e.target.value)
                                }
                                placeholder="₹ Amount"
                                min="100"
                                step="100"
                                disabled={isPlacingBet}
                                autoFocus
                            />

                            {betStake &&
                                parseFloat(betStake) >= 100 && (
                                    <div className="bet-calculationxss">
                                        <strong>
                                            {selectedBet.type === 'back'
                                                ? `₹${(
                                                    parseFloat(betStake) *
                                                    (selectedBet.price - 1)
                                                ).toFixed(2)}`
                                                : `₹${parseFloat(betStake)}`}
                                        </strong>
                                    </div>
                                )}

                        </div>

                        {/* BODY */}
                        <div
                            className={`bet-slip-body ${
                                selectedBet.type === 'back' ||
                                selectedBet.type === 'yes'
                                    ? 'is-back'
                                    : 'is-lay'
                            }`}
                        >

                            <div className="bet-input-group">

                                <label>
                                    Stake (Min ₹100)
                                </label>

                                <div className="quick-stakes">

                                    {[
                                        500,
                                        1000,
                                        5000,
                                        10000,
                                        25000,
                                        50000,
                                        75000,
                                        100000
                                    ].map((amt) => (

                                        <button
                                            key={amt}
                                            onClick={() =>
                                                setBetStake((prev) =>
                                                    String(
                                                        parseFloat(prev || 0) +
                                                        amt
                                                    )
                                                )
                                            }
                                            disabled={isPlacingBet}
                                        >
                                            {amt >= 1000
                                                ? `${amt / 1000}K`
                                                : amt}
                                        </button>

                                    ))}

                                </div>

                            </div>

                            <div className="bet-actions">

                                <button
                                    className="reset"
                                    onClick={() => {
                                        setBetStake('');
                                        setShowBetSlip(false);
                                        setSelectedBet(null);
                                    }}
                                    disabled={isPlacingBet}
                                >
                                    Reset
                                </button>

                                <button
                                    type="button"
                                    className="place-bet-btn"
                                    disabled={
                                        !betStake ||
                                        parseFloat(betStake) < 100 ||
                                        isPlacingBet
                                    }
                                    onClick={() => {

                                        placeBet();

                                        setShowBetSlip(false);
                                        setBetStake('');
                                        setSelectedBet(null);
                                    }}
                                >
                                    {isPlacingBet
                                        ? 'Placing Bet...'
                                        : 'Place Bet'}
                                </button>

                            </div>

                        </div>

                    </div>

                </div>

            </div>,
            document.body
        )}

    </>
)}


                        <div className="matched-bets-section">
                          <div className="simple-bets-container">
                                {/* PURPLE HEADER (Always Visible) */}
                                <div className="summary-header">
                                    <h3>My Bet</h3>
                                    {/* Only show the Show/Hide button if there are actually bets to show */}
                                    {(currentMatchBets.bookmaker.length > 0 ||
                                     currentMatchBets.bookmaker2.length > 0 ||
                                     currentMatchBets.bookmakerTied.length > 0 ||
                                     currentMatchBets.session.length > 0) && (
                                        <button onClick={toggleAllBets}>
                                            {showAllBets ? 'Hide' : 'Show'}
                                        </button>
                                    )}
                                </div>

                                {/* CONTENT AREA (Empty State OR Bets List) */}
                                {currentMatchBets.bookmaker.length === 0 &&
                                 currentMatchBets.bookmaker2.length === 0 &&
                                 currentMatchBets.bookmakerTied.length === 0 &&
                                 currentMatchBets.session.length === 0 ? (
                                    
                                    <div style={{ padding: '15px', textAlign: 'center', color: '#999', fontSize: '13px', background: '#ffffff' }}>
                                        No bets placed yet on this match.
                                    </div>

                                ) : (
                                    /* BETS LIST: Only shown when showAllBets is true */
                                    showAllBets && (
                                        <div className="simple-bets-box">
                                            {/* HEADER ROW */}
                                            <div className="simple-bets-header">
                                                <span>Matched Bet</span>
                                                <span>Odds</span>
                                                <span>Stake</span>
                                            </div>

                                            {/* 🔵 BOOKMAKER */}
                                            {currentMatchBets.bookmaker.map((bet, idx) => (
                                                <div
                                                    key={`bm-${idx}`}
                                                    className={`simple-bets-row ${bet.betType === 'back' ? 'is-back' : 'is-lay'}`}
                                                >
                                                    <span>{bet.selectionName}</span>
                                                    <span>{bet.odds}</span>
                                                    <span>₹{bet.stake}</span>
                                                </div>
                                            ))}

                                            {/* 🔵 BOOKMAKER 2 */}
                                            {currentMatchBets.bookmaker2.map((bet, idx) => (
                                                <div
                                                    key={`bm2-${idx}`}
                                                    className={`simple-bets-row ${bet.betType === 'back' ? 'is-back' : 'is-lay'}`}
                                                >
                                                    <span>{bet.selectionName}</span>
                                                    <span>{bet.odds}</span>
                                                    <span>₹{bet.stake}</span>
                                                </div>
                                            ))}

                                            {/* 🔵 BOOKMAKER TIED */}
                                            {currentMatchBets.bookmakerTied.map((bet, idx) => (
                                                <div
                                                    key={`bmt-${idx}`}
                                                    className={`simple-bets-row ${bet.betType === 'back' ? 'is-back' : 'is-lay'}`}
                                                >
                                                    <span>{bet.selectionName}</span>
                                                    <span>{bet.odds}</span>
                                                    <span>₹{bet.stake}</span>
                                                </div>
                                            ))}

                                            {/* 🔵 SESSION */}
                                            {currentMatchBets.session.map((bet, idx) => (
                                                <div
                                                    key={`sess-${idx}`}
                                                    className={`simple-bets-row ${bet.betType === 'yes' ? 'is-back' : 'is-lay'}`}
                                                >
                                                    <span>{bet.selectionName}</span>
                                                    <span>{bet.odds}</span>
                                                    <span>₹{bet.stake}</span>
                                                </div>
                                            ))}

                                        </div>
                                    )
                                )}
                            </div>
                        </div>
                    </div>

                </div>
            </div>

                    <section className="footer app-footer">
                
                {/* 1. TOP ROW: Links, Support, Social */}
                <div className="footer-top">
                    <div className="footer-links">
                        <nav className="navbar navbar-expand-sm">
                            <ul className="navbar-nav">
                                <li className="nav-item">
                                    <a className="nav-link" href="/terms-and-conditions" target="_blank">
                                        Terms and Conditions
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="/responsible-gaming" target="_blank">
                                        Responsible Gaming
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div className="support-detail">
                        <h2>24X7 Support</h2>
                    </div>
                    <div className="social-icons-box"></div>
                </div>

                {/* 2. MIDDLE ROW: SSL Badge + Icons */}
                <div className="footer-bottom">
                    <div className="secure-logo">
                        <div>
                            <img src="https://wver.sprintstaticdata.com/v3/static/front/img/ssl.png" alt="SSL Secure" />
                        </div>
                        <div className="ml-2">
                            <b>100% SAFE</b>
                            <div>Protected connection and encrypted data.</div>
                        </div>
                    </div>
                    <div className="d-inline-block">
                        <button className="btn p-0">
                            <img src="https://versionobj.ecoassetsservice.com/v105/static/front/img/18plus.png" alt="18+" />
                        </button>
                        <a href="https://www.gamcare.org.uk/" target="_blank">
                            <img src="https://versionobj.ecoassetsservice.com/v105/static/front/img/gamecare.png" alt="Gamecare" />
                        </a>
                        <a href="https://www.gamblingtherapy.org/" target="_blank">
                            <img src="https://versionobj.ecoassetsservice.com/v105/static/front/img/gt.png" alt="GT" />
                        </a>
                    </div>
                </div>

                {/* 3. BOTTOM ROW: Copyright Text */}
                <div className="footer-text">
                    <p className="text-centerx">
                        © Copyright {new Date().getFullYear()}. All Rights Reserved. Powered by WAZIRBOOK.
                    </p>
                </div>
            </section>
        </div>
    

        
    );
};

export default UnifiedMatchDetails;